import i18n from "i18next";
import { initReactI18next } from "react-i18next";

// the translations
// (tip move them in a JSON file and import them,
// or even better, manage them separated from your code: https://react.i18next.com/guides/multiple-translation-files)
const resources = {
  en: {
    translation: {

      // Login/Registration
      "login":            "Login",
      "register":         "Register",
      "forgot_password":  "Forgot Password",
      "email":            "Email",
      "password":         "Password",
      "username":         "Username",
      "confirm_password": "Confirm Password",
      "password_requirements": "Password must be contain at least 8 characters, one uppercase letter, one lowercase letter, one number and one special character.",

      // Header Values
      "dashboard":     "Dashboard",
      "home":          "Home",
      "filters":       "Filters",
      "reset_filters":   "Reset All Filters",
      "done":            "Done",
      "all_time":        "All time",
      "this_month":      "This month",
      "last_3_months":   "Last 3 months",
      "last_year":       "Last year",

      // Tab Buttons
      "overview":      "Overview",
      "births":        "Herd",
      "deaths":        "Deaths",
      "rain":          "Rain",
      "temperatures":  "Temperatures",
      "areas":         "Areas",
      "breeds":        "Breeds",
      "unknown":       "Unknown",
      "reproduction":  "Reproduction",
      "team":          "Team",
      "charts":        "Charts",
      "corral_manager": "ZM Corral",
      "messages":      "Messages",
      "whatsapp":      "WhatsApp",
      "protocols":     "Protocols",
      "plans":         "Plans",
      "animals":       "Animals",
      "ranch_settings": "Ranch Settings",
      "climate":        "Climate",
      "log":            "Your Messages",
      "samples":        "Samples",
      "try_it":         "Try It",
      "phone_number":   "Phone Number",

      // Try It
      "try_it_title":       "Test WhatsApp Messages",
      "settings":           "Settings",
      "try_it_description": "Send test messages to see how the system processes them. Messages will be saved to your account.",
      "try_it_placeholder": "Enter your message here...\n\nExample:\n12345 m nelore\n12346 f angus",
      "try_it_empty":       "Send a message to see the response",
      "try_it_no_match":    "Message not recognized. Check the Samples tab for valid message formats.",
      "try_it_error":       "Error processing message",

      // Phone Number
      "phone_number_title":       "Your WhatsApp Phone Number",
      "phone_number_description": "This is your dedicated phone number for ZapManejo. Your team members can send WhatsApp messages to this number to record ranch data.",
      "reveal_phone_number":      "Reveal Phone Number",
      "phone_number_error":       "Could not retrieve phone number. Please try again.",

      "send":               "Send",
      "sending":            "Sending...",
      "clear":              "Clear",
      "select_date":        "Select date (optional)",

      // Overview Screen
      "overview_title":       "Overview",
      "total_herd":           "Total Herd",
      "total_team_members":   "Team Members",
      "total_custom_breeds":  "Custom Breeds",
      "total_bulls":          "Bulls",
      "total_messages":       "Messages Parsed",
      "whatsapp_usage":       "WhatsApp Usage",
      "total_areas":          "Total Areas",
      "active_reproduction_lots": "Reproduction Lots",
      "active_weight_lots":       "Weight Lots",
      "active_lists":             "Active Lists",
      "none": "None",

      // Weight
      "weight":               "Weight",
      "weight_kg":            "Weight (kg)",
      "weight_data":          "Weight Data",
      "weight_chart":         "Weight Chart",
      "weight_charts":        "Weight Charts",
      "weights_by_tag":       "Weights by Tag",
      "weight_lots":          "Lots",
      "slaughter_predict_tab": "Slaughter Predict",
      "slaughter_tab":        "Slaughter",

      // Slaughter tab
      "slaughter_section_title":   "Slaughter Records",
      "slaughter_section_text":    "Record the results from the abattoir once a lot is processed. Capture the carcass yield percentage and animal count to close out the lot and compare actual results against projections.",
      "slaughter_record_title":    "Record Slaughter",
      "slaughter_abattoir":        "Abattoir Name",
      "slaughter_yield_pct":       "Carcass Yield %",
      "slaughter_animal_count":    "Animal Count",
      "slaughter_record_button":   "Save Record",
      "slaughter_history":         "Slaughter History",
      "slaughter_yield_chart_title": "Carcass Yield by Lot",
      "slaughter_yield_chart_sub":   "Green bars are at or above industry average. Red bars are below.",
      "avg_yield":                   "Avg Yield",
      "best_yield":                  "Best Yield",
      "industry_avg":                "Industry avg",
      "no_slaughter_records":        "No slaughter records with yield data yet.",
      "slaughter_record_success":  "Slaughter record saved.",
      "slaughter_record_error":    "Error saving record. Please try again.",
      "col_lot_code":              "Lot",
      "col_abattoir":              "Abattoir",
      "col_animal_count":          "Animals",
      "col_yield_pct":             "Yield %",

      "avg_current_weight":   "Avg Current Weight",
      "lot_avg_weight_chart_label": "Average weight of all animals in this lot over time",
      "lot_session_weight_chart_label": "Recorded lot weight over time",
      "proj_target_date":     "Project to Date",
      "proj_target_weight":   "Project to Weight",
      "proj_by_date_label":   "Projected",
      "proj_by_weight_label": "Projected",
      "adg_column":           "Avg Daily Gain",
      "days_to_target":       "Days to Target",
      "predict_date":         "Est. Ready Date",
      "ready_for_slaughter":  "✓ Ready",
      "enrolled_at":          "Enrolled",
      "days_on_feed":         "Days on Feed",
      "first_weigh_date":     "1st Weigh Date",
      "first_weigh_value":    "1st Weight",
      "last_weigh_date":      "Last Weigh Date",
      "last_weigh_value":     "Last Weight",
      "latest_weight":        "Latest Weight",
      "total_weigh_ins":      "Weigh Ins",
      "no_weigh_ins":         "No weigh-ins recorded.",
      "last_weigh_in":        "Last Weigh-in",
      "sessions":             "Sessions",
      "select_weight_lot":    "Select weight lot...",
      "all_weight_lots":      "All weight lots",
      "enroll_animal":        "Add Animal to Lot",
      "weight_active_section_title": "Animals in Weight Lots",
      "weight_active_section_text":  "Animals currently enrolled in active weight lots. Filter by tag or lot to view individual progress.",
      "weight_animals_section_title": "Manage Weight Your Way",
      "weight_animals_section_text":  "Track your herd's weight in 3 flexible ways.\n\n🐄 By Animal — enter each animal's weight and we calculate ADG and progress automatically.\n⚖️ By Lot Weight — simply record the average weight of your lot over time, no individual scanning needed.\n📊 By Score — use your own scoring system (e.g. -3 to +3) to rate lot condition at a glance.\n\nMix and match within any lot.",
      "weight_lots_section_title":   "Weight Lots",
      "weight_lots_section_text":    "Weight lots are a group of animals in which weight is being tracked. You can track weight individually per animal by adding weight per animal or you can track the lot's weight with a simple score.",

      // Weight lot expanded panel
      "weightSessions":       "Lot Weights",
      "noWeighIns":           "No weigh-ins recorded yet.",
      "lotNotes":             "Notes",
      "noNotes":              "No notes yet.",
      "writeNote":            "Write a note...",
      "adding":               "Adding...",
      "addNote":              "Add Note",
      "locationHistory":      "Location History",
      "currentLocation":      "Current Location",
      "noLocation":           "Not set",
      "select_location":      "Select Location",
      "locationName":         "Location",
      "locationPlaceholder":  "e.g. Pasture 3",
      "moveDate":             "Date",
      "recordMove":           "Add",
      "noMoves":              "No location history yet.",
      "current":              "Current",
      "default_weight_lot":      "Default Weight Lot",
      "default_weight_lot_hint": "When a weight measurement is received via WhatsApp and the animal is not yet in a lot, it will automatically be enrolled in this lot.",
      "default_weight_lot_section_title": "Default Weight Lot",
      "default_weight_lot_section_text":  "Set a default lot for automatic WhatsApp enrollment when no lot is specified.",
      "weight_lot_name":             "Lot Name",
      "weight_lot_name_placeholder": "e.g. Summer Cycle 2025",
      "tracking_method_question":      "How will you track weight on this lot?",
      "tracking_method_required_hint": "Choose one — this determines which sections appear on the lot page.",
      "tracking_method_animal":            "Per-Animal",
      "tracking_method_animal_desc":       "Track individual weigh-ins per tagged animal, with target weight and ADG.",
      "tracking_method_lot_average":       "Lot Average",
      "tracking_method_lot_average_desc":  "Track a single median weight for the whole lot over time.",
      "tracking_method_score":             "Body Score",
      "tracking_method_score_desc":        "Track a body condition score for the lot instead of a scale weight.",
      "tracking_method_combination":       "Combination",
      "tracking_method_combination_desc":  "Use more than one method — show all sections on this lot.",
      "target_weight_optional":        "Target Weight (kg, optional)",
      "adg_estimate_optional":         "Est. Daily Gain (kg/day, optional)",
      "lot_plan_optional":           "Plan (optional)",
      "no_plan":                     "No plan",
      "weight_lot_code":             "Lot Code",
      "median_lot_weight":           "Entry Weight (kg)",
      "mlw_note":                    "Average weight of the animals when they entered this lot.",
      "adg_label":                   "Expected Daily Gain (kg/day)",
      "adg_note":                    "Your best estimate of how many kg each animal gains per day. Used to predict the slaughter date until real weigh-in data is available.",
      "adg_calculated_label":        "Daily Gain (Calculated)",
      "adg_estimated_label":         "Daily Gain (Your Estimate)",
      "target_weight":               "Target Weight",
      "target_weight_note":          "The weight at which animals are considered ready for slaughter.",
      "lot_weight_progress":         "Lot Weight Progress",
      "select_lot_to_view":          "Select a lot to view its chart",
      "est_today":                   "Est. Today",
      "of_target":                   "of target",
      "projected_target":            "Projected Target",
      "rename_lot":                  "Rename Lot",
      "rename_lot_note":             "Give this lot a friendly name to identify it more easily.",
      "rename_lot_placeholder":      "e.g. Summer Cycle 2026",
      "estimated_exit_date":         "Est. Exit Date",
      "lot_target_weight":           "Target Weight (kg)",
      "lot_target_weight_note":      "The weight at which animals in this lot are considered ready for slaughter.",
      "lot_created_at":              "Start Date",
      "lot_color":                   "Color",
      "system_assigned":             "system assigned",
      "auto_assigned":               "auto assigned",
      "mlw_required":                "Entry weight is required.",
      "head_count_required":         "Head count is required.",
      "error_creating_weight_lot":   "Error creating lot. Please try again.",

      // Lot detail page
      "lot_scores":              "Scores",
      "last_score_short":        "Last",
      "score_value":             "Score",
      "no_scores":               "No scores recorded.",
      "add_score":               "Add Score",
      "wat_send_via_whatsapp":   "Send via WhatsApp:",
      "wat_add_animal":          "Add animal",
      "wat_record_score":        "Record score",
      "wat_query_lot":           "Query lot",
      "wat_shorthand":           "Shorthand (no lot code)",
      "wat_add_animals":         "Add animals",
      "wat_default_set":         "Default lot updated",
      "wat_copy":                "Copy",
      "wat_protocol_start":      "Start tracking",
      "wat_protocol_done":       "Mark current step done",
      "wat_protocol_stop":       "Stop tracking",
      "wat_list_default_set":    "Default list updated",
      "wat_add_list_item":       "Add item",
      "wat_query_list":          "Query list",
      "wat_list_shorthand":      "Shorthand (default list)",
      "wat_list_item_example":   "product",
      "wat_list_created":        "created",
      "wat_list_mark_purchased": "Mark as purchased",
      "wat_list_purchased_keyword": "purchased",
      "end_feed_lot":            "End Feed Lot / Record Slaughter",
      "slaughter_info":          "Slaughter Record",
      "scored_at":               "Recorded At",
      "samples_weight_lot_score_title":        "Lot Score",
      "samples_weight_lot_score_description":  "Record a feed score for a lot",
      "samples_weight_lot_score_response":     "✅ Score -3 recorded for WEIGHT-0005 (Feedlot A).",
      "last_weigh_in_short":  "Last",
      "notes_label":          "notes",
      "animal_weigh_ins":     "Animal Weigh-ins",
      "no_animals":           "No animals enrolled",
      "archive_lot":          "Archive Lot",
      "unarchive_lot":        "Reactivate Lot",
      "target_reached":       "Target weight reached!",
      "archive_suggestion":   "Consider archiving this lot now that animals are ready for slaughter.",
      "archive_confirm":      "Are you sure you want to archive this lot?",
      "lot_status_active":    "Active",
      "lot_status_archived":  "Archived",

      "role":                 "Role",
      "status":               "Status",
      "owner":                "Owner",
      "manager":              "Manager",
      "messenger":            "Messenger",
      "active":               "Active",
      "pending":              "Pending",
      "select_role":          "Select a role...",
      "send_invite":          "Send Invite",
      "invite_sent":          "Invite sent successfully",
      "invite_error":         "Error sending invite",
      "error_user_exists":    "A user with this email already exists",
      "error_adding_team":    "Error adding team member",
      "billing_owner_only":    "Only the owner of the account can make changes to billing and subscriptions.",
      "role_feature_dashboard": "Dashboard access",
      "role_feature_billing": "Billing management",
      "role_feature_data":    "Data entry & management",
      "role_feature_whatsapp": "WhatsApp messaging",
      "start_weight":         "Start Weight",
      "end_weight":           "End Weight",
      "weight_gained":        "Weight Gained",
      "weight_over_time":     "Weight Over Time",
      "select_animals":       "Select Animals",
      "enter_tag_number":     "Enter tag number",
      "select_animals_to_display": "Select animals to display chart",

      // Chart summaries
      "chart_summary_herd_by_breed":    "{{percent}}% of your herd is {{breed}}.",
      "chart_summary_no_herd_data":     "No animals recorded yet.",
      "other_breeds":                   "Other breeds",
      "chart_summary_top_cause":        "The most common cause of death is {{cause}} ({{percent}}%).",
      "chart_summary_no_deaths":        "No deaths recorded.",
      "other_causes":                   "Other causes",
      "chart_summary_age_range":        "{{count}} animals aged 7–12 months.",
      "chart_summary_no_age_data":      "No animals in this age range.",
      "chart_summary_repro_this_month": "{{count}} animals tracked this month — {{result}} is the most common result.",
      "chart_summary_no_repro_month":   "No reproduction data for this month.",
      "chart_summary_best_lot":         "{{lot}} achieved the highest pregnancy success at {{percent}}%.",
      "chart_summary_no_repro_data":    "No reproduction data recorded yet.",
      "chart_summary_rainfall":         "{{total}}mm total rainfall. Wettest month: {{month}} ({{amount}}mm).",
      "chart_summary_no_rainfall":      "No rainfall data recorded.",
      "chart_summary_temperature":      "Average temperature in {{month}} was {{temp}}°C.",
      "chart_summary_no_temperature":   "No temperature data recorded.",
      "chart_summary_weight_tracking":  "Tracking weights for {{count}} animals.",
      "chart_summary_no_weight_data":   "No weight data recorded.",
      "chart_summary_finance_profit":      "{{amount}} net over the last 12 months.",
      "chart_summary_finance_month":       "{{gains}} in, {{losses}} out this month.",
      "chart_summary_finance_institution": "{{institution}} has the highest net balance at {{amount}}.",
      "chart_summary_no_finance_data":     "No financial data recorded yet.",

      // Charts
      "select_chart":         "Select Chart",
      "herd_by_breed":        "Herd by Breed",
      "herd_by_cause_of_death":  "Deaths by Cause",
      "rainfall_by_month":    "Rainfall by Month",
      "total_rainfall_by_month": "Total Rainfall by Month",
      "rainfall_mm":          "Total Rainfall (mm)",
      "temperature_by_month": "Average Temperature by Month",
      "temperature_celsius":  "Temperature (°C)",
      "month":                "Month",
      "reproduction_recent":  "Recent Reproduction Results",
      "reproduction_success": "Reproduction Success by Group",
      "all":                  "All",
      "age_category":         "Calves Weaning off Milk",
      "seven_months":         "7 months",
      "eight_months":         "8 months",
      "nine_months":          "9 months",
      "ten_twelve_months":    "10-12 months",
      "pregnant":             "Pregnant",
      "returned_to_estrus":   "Returned to Estrus",
      "aborted":              "Aborted",
      "calved_alive":         "Calved (Alive)",
      "calved_stillborn":     "Calved (Stillborn)",
      "dam_died":             "Dam Died",

      // Screen Titles
      "births_title":      "Births",
      "births_add":        "Add Birth",
      "deaths_title":      "Deaths",
      "deaths_add":        "Add Death",
      "rainfall_title":    "Rainfall",
      "rainfall_add":      "Add Rainfall",
      "temperature_title": "Temperatures",
      "temperature_add":   "Add Temperature",
      "areas_title":       "Areas",
      "area_add":          "Add Area",
      "team_title":        "Team",
      "team_add":          "Add Team Member",

      // Protocols
      "description":           "Description",
      "duration":              "Duration",
      "target_animals":        "Target Animals",
      "protocol_type":         "Type",
      "protocol_type_system":  "System",
      "protocol_type_custom":  "Custom",
      "add_protocol":          "Add Protocol",
      "add_plan":              "Add Plan",
      "edit_plan":             "Edit Plan",
      "save_plan":             "Save Plan",
      "update_plan":           "Update Plan",
      "add_herd_plan":         "Add Herd Plan",
      "edit_herd_plan":        "Edit Herd Plan",
      "add_weight_plan":       "Add Weight Plan",
      "edit_weight_plan":      "Edit Weight Plan",
      "select_plan":           "Select Plan",
      "assign_plan":           "Assign Plan",
      "change_plan":           "Change Plan",
      "no_active_plan":        "No plan assigned to this lot.",
      "plan_progress":         "Plan Progress",
      "lot_plan_section_title": "Tracking a Lot's Plan",
      "plan_name":             "Plan",
      "error_creating_plan":   "Error creating plan",
      "error_updating_plan":   "Error updating plan",
      "system_plan_readonly":  "This is a system plan and cannot be edited.",
      "basic_info":            "Basic Information",
      "timeline":              "Timeline",
      "day":                   "Day",
      "to":                    "To",
      "days":                  "days",
      "days_label":            "Days",
      "event":                 "Event",
      "event_placeholder":     "What happens on this day?",
      "treatments":            "Treatments",
      "medication":            "Medication",
      "device":                "Device",
      "procedure":             "Procedure",
      "add_treatment":         "Add Treatment",
      "add_action":                        "Add Action",
      "action_placeholder":                "What should the operator check? (e.g. Check for ticks, Remove implant)",
      "attach_action":                     "+ Attach action",
      "create_action":                     "Add New Action",
      "step_note":                         "Note (dose, brand, variation, etc.)",
      "step_note_herd":                    "Note (product, dose, instructions)",
      "step_note_weight":                  "Note (instructions)",
      "step_note_placeholder_herd":        "Optional instructions for this step, e.g. \"Clostridial vaccine, 5 mL under the skin\"",
      "step_note_placeholder_weight":      "Optional instructions for this step, e.g. \"Weigh before feeding\"",
      "action_placeholder_herd":           "What should the operator do? (e.g. Vaccinate, Deworm, Check for ticks)",
      "action_placeholder_weight":         "What should the operator do? (e.g. Weigh, Check body condition)",
      "step_note_placeholder":             "Optional instructional text for this step, e.g. \"1.0 mL for heifers, 2.0 mL for cows\"",
      "add_timeline_day":                  "Add Timeline Day",
      "add_step":                          "Add Step",
      "add_step_note":                     "Add Step Note",
      "no_steps_in_phase":                 "No steps added yet.",
      "phase_pre_insemination":            "Pre-Insemination",
      "phase_pre_insemination_hint":       "Steps taken before insemination, such as hormone priming, vitamins, or animal preparation.",
      "phase_insemination":                "Insemination",
      "phase_insemination_hint":           "The insemination event itself and any same-day procedures.",
      "phase_post_insemination":           "Post-Insemination",
      "phase_post_insemination_hint":      "Steps after insemination, including pregnancy verification and result recording.",
      "system_action_mark_all_pregnant":              "Let the system mark all animals as pregnant",
      "system_action_mark_all_pregnant_tooltip_title": "⚙️ System Action",
      "system_action_mark_all_pregnant_tooltip":       "ZapManejo will automatically set all animals to pregnant on this day.",
      "system_action_notify_birthing_window":              "Let the system notify the team the birthing window has opened",
      "system_action_notify_birthing_window_tooltip_title": "⚙️ System Action",
      "system_action_notify_birthing_window_tooltip":       "ZapManejo will send a heads-up to the team on this day letting them know this lot's calving window has opened. No animal status changes — informational only.",
      "system_action_mark_lost_pregnancies":              "Let the system mark animals that haven't calved as lost pregnancies",
      "system_action_mark_lost_pregnancies_tooltip_title": "⚙️ System Action",
      "system_action_mark_lost_pregnancies_tooltip":       "ZapManejo will mark any animal that hasn't calved out by this day as a lost pregnancy and notify the team with the list of affected tags. Animals already marked not pregnant, or that have already calved, are left alone.",
      "system_action_mark_lot_archived":              "Let the system archive this lot",
      "system_action_mark_lot_archived_tooltip_title": "⚙️ System Action",
      "system_action_mark_lot_archived_tooltip":       "ZapManejo will automatically archive this lot on this day, ending protocol tracking and releasing every enrolled animal so they're available for a new cycle. You can always archive it manually earlier via the lot's Status dropdown.",
      "protocol_missing_archive_step_nudge": "This protocol doesn't end with an archive step — lots created from it won't automatically archive. You can still save, or add a Mark Lot Archived step to the last day.",
      "saving":                "Saving...",
      "save":                  "Save",
      "saved":                 "Saved ✓",
      "account":               "Account",
      "ranches":               "Ranches",
      "ranch":                 "Ranch",
      "ranch_name":            "Ranch Name",
      "address":               "Address",
      "setup_welcome_title":         "Welcome to ZapManejo!",
      "setup_welcome_subtitle":      "Let's set up your first ranch to get started.",
      "ranch_details_section_title": "Ranch Details",
      "ranch_details_section_text":  "Set the name and address for this ranch. The ranch name appears in the sidebar and in reports.",
      "ranch_nickname_placeholder":  "WhatsApp Alias (e.g. terp)",
      "ranch_nickname_hint":         "Short alias used in WhatsApp to switch ranches — e.g. send \"ranch terp\" to switch to this ranch.",
      "ranches_section_title": "Ranches",
      "ranches_section_text":  "Manage the ranches on your account. Each ranch has its own herd, weight, reproduction, and financial records.",
      "save_protocol":         "Save Protocol",
      "edit_protocol":         "Edit Protocol",
      "update_protocol":       "Update Protocol",
      "error_creating_protocol": "Error creating protocol",
      "error_updating_protocol": "Error updating protocol",
      "system_protocol_readonly": "This is a system protocol and cannot be edited.",
      "cancel":                "Cancel",
      "cows":                  "Cows",
      "heifers":               "Heifers",

      // Lists
      "lists":                     "Lists",
      "lists_list":                "List",
      "lists_item_count":          "Items",
      "lists_all":                 "Lists",
      "lists_categories":          "Categories",
      "list_prefix":               "LIST",
      "lists_all_section_title":        "Lists",
      "lists_all_section_text":         "Manage your ranch's lists. Add items via WhatsApp with LIST (e.g. LIST salt) or from this screen.",
      "lists_categories_section_title": "List Categories",
      "lists_categories_section_text":  "Manage categories for your lists. Categories help organize and sort items for printing.",
      "lists_item":                     "Item",
      "lists_added_by":                 "Added By",
      "lists_filter_pending":           "Pending",
      "lists_filter_all":               "All",
      "lists_filter_active":            "Active",
      "lists_filter_archived":          "Archived",
      "lists_filter_both":              "Both",
      "lists_all_lists":                "All Lists",
      "lists_unarchive":                "Unarchive List",
      "lists_expires_at":               "Closes",
      "lists_no_expiry":                "No closing date",
      "lists_expires_placeholder":      "Closing date (optional)",
      "lists_status_pending":           "Pending",
      "lists_status_purchased":         "Purchased",
      "lists_status_completed":         "Completed",
      "lists_cost":                     "Cost",
      "lists_cost_optional":            "Cost (optional)",
      "lists_no_cost_hint":             "No cost entered: no expense is recorded in the project.",
      "lists_completed_hint":           "Completed items never record an expense. Use Purchased to record the cost.",
      "lists_project":                  "Project",
      "lists_no_project":               "Not linked to a project",
      "lists_link_project":             "Link to project",
      "lists_project_hint":             "Purchased items with a cost become expenses in this project.",
      "lists_project_link_error":       "Could not link the project.",
      "edit":                           "Edit",
      "lot_projects_optional":          "Projects (optional)",
      "lot_no_project":                 "Not linked to any project",
      "lot_project_none_yet":           "No active projects yet. Create one under Finances → Projects to track this lot's costs.",
      "lot_project_hint":               "Expenses and income tagged to this project count toward it. A lot can be in several projects, and a project can cover several lots.",
      "lot_project_link_error":         "Could not link the project.",
      "lot_project_unlink_error":       "Could not remove the project.",
      "lists_items":                    "Items",
      "lists_done":                     "Done",
      "lists_done_of":                  "{{done}} of {{total}}",
      "lists_spent":                    "Spent",
      "lists_aliases_placeholder":      "e.g. hardware; store",
      "lists_finance_category_default": "Other (default category)",
      "project_not_active":             "That project is closed.",
      "invalid_list_item":              "Invalid item: check the name, status and cost.",
      "lists_no_lists":                 "There are no records to display.",
      "lists_new":                      "New List",
      "lists_name_placeholder":         "List name (optional)",
      "lists_create":                   "Create",
      "lists_set_default":              "★ Set as Default",
      "lists_archive":                  "Archive List",
      "lists_archive_confirm":          "Confirm Archive",
      "lists_no_items":                 "No items found.",
      "lists_print":                    "Print",
      "lists_select_list":              "Select list",
      "lists_item_placeholder":         "Item description",
      "lists_no_category":              "No category",
      "lists_save":                     "Save Changes",
      "lists_item_saved":               "Item saved.",
      "lists_item_save_error":          "Error saving item. Please try again.",
      "lists_delete_item":              "Delete Item",
      "lists_delete_confirm":           "Tap to confirm delete",
      "lists_item_delete_error":        "Error deleting item. Please try again.",

      // Finances
      "finances":                  "Finances",
      "transactions":              "Transactions",
      "finance_charts":            "Finance Charts",
      "finance_settings":          "Finance",
      "gain":                      "Gain",
      "loss":                      "Loss",
      "gains":                     "Gains",
      "losses":                    "Losses",
      "category":                  "Category",
      "categories":                "Categories",
      "finance_categories":        "Financial Categories",
      "animal_sale":               "Animal Sale",
      "animal_purchase":           "Animal Purchase",
      "labor":                     "Labor",
      "feed":                      "Feed",
      "veterinary":                "Veterinary",
      "equipment":                 "Equipment",
      "fuel":                      "Fuel",
      "other":                     "Other",
      "other_categories":          "Other categories",
      "currency":                  "Currency",
      "currency_brl":              "Brazilian Real (R$)",
      "currency_usd":              "US Dollar ($)",

      // Section descriptions
      "herd_section_title": "Herd",
      "herd_section_text":  "Your complete animal registry. Each record represents one animal identified by a tag number. Records are created automatically when your team sends birth messages via WhatsApp, or you can add and upload them manually here.",

      "herd_animals_section_title": "Herd Animals",
      "herd_animals_section_text":  "Your complete animal registry. Each record represents one animal identified by a tag number.",
      "herd_lots_section_title":    "Herd Lots",
      "herd_lots_section_text":     "Group animals into lots for tracking location and movement. Send \"new herd lot\" via WhatsApp or add one here.",
      "herd_plans_section_title":    "Plans",
      "herd_plans_section_text":     "General plans that can be assigned to herd lots.",
      "herd_settings_section_title": "Settings",
      "herd_settings_section_text":  "Configure defaults used when creating herd lots via WhatsApp.",

      "herd_lots":                  "Lots",
      "herd_lot_prefix":            "HERD",
      "select_herd_lot":            "Select herd lot",
      "herd_lot_code":              "Lot Code",
      "herd_lot_name":              "Lot Name",
      "herd_lot_name_placeholder":  "e.g. North Pasture",
      "error_creating_herd_lot":    "Error creating herd lot. Please try again.",
      "no_herd_lots":               "No herd lots yet.",
      "wat_add_animals_to_lot":     "Add animals (tag, sex, breed per line)",
      "created":                    "created",

      // Ranch Settings section descriptions
      "team_section_title":     "Team Members",
      "team_section_text":      "Register the WhatsApp phone numbers that can send data to your ranch. Each member's number is matched to your account when a message arrives. Owners and managers can add new records; messengers can only send data. Each team member is assigned to a single ranch — when sending data via WhatsApp, the data entered or returned will be for their assigned ranch.",
      "areas_section_title":    "Ranch Areas",
      "areas_section_text":     "Define the pastures and paddocks on your ranch. Add WhatsApp aliases so members can use shorthand in messages — for example, type \"p1\" and it will be recorded as \"Pasture 1\".",
      "breeds_section_title":   "Cattle Breeds",
      "breeds_section_text":    "Define the breeds in your herd. Add WhatsApp aliases for faster typing — for example, \"nel\" will be recognized as \"Nelore\" when logging births or weights via WhatsApp.",
      "death_causes_section_title":  "Death Causes",
      "death_causes_section_text":   "Define the reasons an animal may die. System causes are provided by default. Add custom causes specific to your ranch.",
      "death_causes":                "Death Causes",
      "death_cause":                 "Death Cause",
      "Slaughtered":                 "Slaughtered",
      "Sickness":                    "Sickness",
      "Accident":                    "Accident",
      "Old Age":                     "Old Age",
      "Other":                       "Other",
      "death":                       "Death",
      "alive":                       "Alive",
      "dead":                        "Dead",
      "mark_as_dead":                "Mark this animal as dead",
      "all_causes":                  "All Causes",
      "select_cause":                "Select Cause",
      "all_statuses":                "All Statuses",
      "all_pregnant":                "Any Pregnancy Status",
      "not_pregnant":                "Not Pregnant",
      "system_record_no_delete":     "System records cannot be deleted.",
      "currency_section_title": "Display Currency",
      "currency_section_text":  "Set the currency used to display financial data across the dashboard. This affects how amounts are formatted in reports and charts.",

      "locations_section_title": "Ranch Locations",
      "locations_section_text":  "Define named locations on your ranch — paddocks, pastures, fields. Add WhatsApp aliases so members can use shorthand when recording lot movements via WhatsApp.",
      "locations":               "Locations",
      "lot_fields":                   "Lot Fields",
      "lot_fields_section_title":     "Lot Custom Fields",
      "lot_fields_section_text":      "Define custom metadata fields that appear on every lot — across herd, weight, and reproduction. Each field has a friendly name and WhatsApp aliases so your team can update values by message.",
      "lot_custom_fields":            "Custom Fields",
      "lot_custom_fields_empty":      "No custom fields defined yet.",
      "lot_custom_field_value_empty": "Not set",
      "add_lot_field":                "Add Field",
      "lot_field_friendly_name":      "Field Name",
      "lot_field_db_key":             "Field Key",
      "lot_field_aliases":            "WhatsApp Aliases",
      "lot_field_aliases_hint":       "Separate multiple aliases with a semicolon. e.g. count;contagem",
      "lot_field_type_system":        "System",
      "lot_field_type_custom":        "Custom",
      "tagged_animals":               "Tagged Animals",
      "location_name":           "Location Name",
      "location_name_placeholder": "e.g. North Pasture",
      "no_locations":            "No locations defined yet.",

      // WhatsApp section descriptions
      "whatsapp_samples_section_title": "Message Formats",
      "whatsapp_samples_section_text":  "Browse the WhatsApp message formats your team can use to record ranch data. Send these from any registered phone number to log births, weights, climate, and more.",
      "whatsapp_tryit_section_title":   "Test a Message",
      "whatsapp_tryit_section_text":    "Type a WhatsApp message to see exactly how the system will parse and store it. Use this to verify formats before sharing them with your team.",
      "whatsapp_log_section_title":     "Message History",
      "whatsapp_log_section_text":      "All WhatsApp messages received from your team's registered numbers, along with how each one was parsed and stored.",
      "whatsapp_phone_section_title":   "Your WhatsApp Number",
      "whatsapp_phone_section_text":    "Your ranch's dedicated WhatsApp number. Share this with your team so they know where to send their messages.",

      // Climate section descriptions
      "rain_section_title":         "Rainfall Records",
      "rain_section_text":          "Track daily rainfall across your ranch. Records are added automatically when your team sends rain measurements via WhatsApp.",
      "temperatures_section_title": "Temperature Records",
      "temperatures_section_text":  "Track daily temperature readings. Records are added automatically when your team sends temperature measurements via WhatsApp.",

      // Reproduction section descriptions
      "repro_lots_section_title":             "Reproduction Lots",
      "repro_lots_section_text":              "Group animals into lots to manage reproduction protocols together. Each lot tracks the start date, assigned protocol, and bull.",
      "repro_active_section_title":           "Active Animals",
      "repro_active_section_text":            "View and update the reproduction status of animals currently in a lot. Record results after pregnancy checks and final evaluations.",
      "repro_protocols_section_title":        "Protocols",
      "repro_protocols_section_text":         "Define the FTAI (timed AI) protocols used on your ranch. The default protocol is pre-selected when you create a new lot — use \"Set as default\" to change it.",
      "repro_bulls_section_title":            "Bulls",
      "repro_bulls_section_text":             "Manage the bulls used for natural breeding or as sires in your AI protocols. The default bull is pre-selected when you create a new lot.",
      "repro_settings_section_title":         "Settings",
      "repro_settings_section_text":          "Configure defaults used when creating reproduction lots via WhatsApp.",
      "weight_plans_section_title":   "Plans",
      "weight_plans_section_text":    "Weight management plans that can be assigned to weight lots.",
      "weight_settings_section_title":        "Settings",
      "weight_settings_section_text":         "Configure defaults used when creating weight lots via WhatsApp.",
      "protocol_not_available":               "Protocol details not available.",

      // Weight section descriptions
      "weight_bytag_section_title":  "Weight by Tag",
      "weight_bytag_section_text":   "Look up the full weight history for any animal by tag number. Track individual progress over time.",
      "weight_charts_section_title": "Weight Charts",
      "weight_charts_section_text":  "Visual overview of weight gain progress by lot and carcass yield results from the abattoir.",
      "individual_animal_weights":   "Individual Animal Weights",
      "estimated_weight":            "Estimated",
      "actual_weight":               "Actual",
      "projected_actual":            "Projected (Actual ADG)",
      "weight_data_section_title":   "Weight Records",
      "weight_data_section_text":    "All individual weight measurements across your herd. Records are added automatically when your team sends weight readings via WhatsApp.",

      // Finance section descriptions
      "finance_transactions_section_title": "Transactions",
      "finance_transactions_section_text":  "Record and review all financial transactions — income (gains) and expenses (losses) — organized by date, category, and institution.",
      "finance_projects_section_title":  "Projects",
      "finance_projects_section_text":   "Track whether a project is making or losing money. Tag transactions to a project and its balance adds up on its own: pick the project on a transaction, or name it in a WhatsApp finance message, e.g. \"loss 1200 cement corral\".",
      "projects":                  "Projects",
      "project_code":              "Code",
      "project_balance":           "Balance",
      "project_income":            "Income",
      "project_expenses":          "Expenses",
      "project_status_active":     "Active",
      "project_status_closed":     "Closed",
      "project_name_placeholder":  "Project name, e.g. Corral repair",
      "project_nicknames_placeholder": "Nicknames for WhatsApp, e.g. corral;fence (optional)",
      "all_projects":              "All projects",
      "no_projects":               "No projects yet. Add one to start tracking its balance.",
      "no_project_transactions":   "No transactions in this project yet.",
      "project_list_summary":      "{{done}} of {{total}} done",
      "project_not_found":         "Project not found.",
      "close_project":             "Close project",
      "reopen_project":            "Reopen project",
      "delete_project":            "Delete project",
      "delete_project_confirm":    "Delete this project? Its transactions are kept; they just won't belong to a project anymore.",
      "project_tip_title":         "Log to this project from WhatsApp",
      "lot_tip_title":             "Send to this lot from WhatsApp",
      "list_tip_title":            "Use this list from WhatsApp",
      "project_tip_expense":       "An expense",
      "project_tip_income":        "Income",
      "project_tip_expense_keyword": "loss",
      "project_tip_income_keyword":  "gain",
      "project_name_required":     "The project needs a name.",
      "invalid_project_status":    "Invalid project status.",
      "project":                   "Project",
      "no_project":                "No project",
      "balance_by_project":        "Balance by project",
      "project_balance_over_time": "Balance over time",
      "project_day_change":        "That day",
      "chart_summary_projects":    "{{positive}} in the positive, {{negative}} in the negative.",
      "chart_summary_projects_shown": "Showing the {{shown}} largest of {{total}}.",
      "search_transactions":       "Search transactions…",
      "all_types":                 "All types",
      "all_categories":            "All categories",
      "all_institutions":          "All institutions",
      "date_from":                 "From date",
      "date_to":                   "To date",
      "finance_charts_section_title":       "Financial Charts",
      "finance_charts_section_text":        "Visual breakdowns of your ranch's financial performance, including monthly profit trends and breakdowns by category and institution.",
      "finance_categories_section_title":   "Finance Categories",
      "finance_categories_section_text":    "Define the categories used to classify transactions. Add WhatsApp aliases so your team can use shorthand in messages — for example, \"feed\" maps to \"Feed & Supplements\".",
      "finance_institutions_section_title": "Financial Institutions",
      "finance_institutions_section_text":  "Define the banks, credit lines, and payment methods used on your ranch. Add WhatsApp aliases so your team can reference them quickly in messages.",

      // Charts section description
      "charts_section_title": "Charts",
      "charts_section_text":  "Visual overview of your ranch data — herd composition, reproduction results, climate trends, and weight performance — all in one place.",
      "expand_chart":         "Expand chart",
      "close":                "Close",

      // Billing section description
      "billing_section_title": "Subscription & Billing",
      "billing_section_text":  "Manage your ZapManejo subscription. See your current plan, pick a plan by herd size, and update your payment details.",

      "show_hints":      "Show Hints",
      "hide_hints":      "Hide Hints",
      "default":         "Default",
      "set_as_default":  "Set as default",
      "default_lot_hint": "The default lot receives WhatsApp weight entries automatically. Users can send weight without specifying a LOT-ID and the animal will be enrolled here.",

      "profit_by_month":           "Profit by Month",
      "this_month_by_category":    "This Month by Category",
      "net_by_institution":        "All-Time Net by Institution",
      "net_profit":                "Net Profit",
      "transactions_this_month":   "Transactions This Month",
      "select_type":               "Select Type",
      "select_category":           "Select Category",
      "institution":               "Institution",
      "institutions":              "Institutions",
      "finance_institutions":      "Financial Institutions",
      "select_institution":        "Select Institution",
      "aliases_hint":              "Separate multiple aliases with a semicolon.",

      // Search
      "find_tag":     "Find tag...",
      "all_breeds":   "All Breeds",
      "all_areas":    "All Areas",
      "all_situations":"All Situations",
      "all_sexes":    "All Sexes",
      "all_ages":     "All Ages",
      "months":       "months",

      // Table Titles
      "created_by":   "Created By",
      "tag":          "Tag",
      "tag_prefix":   "TAG",
      "dam":          "Dam",
      "dam_tag_number": "Dam Tag Number",
      "sire_tag_number": "Sire Tag Number",
      "dam_update_failed": "Could not save — check the tag number",
      "sire_update_failed": "Could not save — check the tag number",
      "dam_must_be_female": "The mother must be a female animal",
      "sire_must_be_male": "The father must be a male animal",
      "birth_form_guidance": "Enter a tag number for a tagged animal, or enter a dam number for a newborn calf without a tag yet. You may enter both if known.",
      "breed":        "Breed",
      "cause":        "Situation",
      "sex":          "Sex",
      "age":          "Age",
      "area":         "Area",
      "birth_date":        "Birth Date",
      "registration_date": "Registration Date",
      "date":              "Date",
      "who":               "Who",
      "from":              "From",
      "dam_mother":        "Dam (mother)",
      "sire_father":       "Sire (father)",
      "registered_by":     "Registered By",
      "registered_from":   "Registered From",
      "amount":       "Amount",
      "temperature":  "Temperature",
      "nickname":     "Nickname",
      "nicknames":    "WhatsApp Aliases",
      "nicknames_hint":        "Separate multiple aliases with a semicolon.",
      "nicknames_placeholder": "WhatsApp aliases, semicolon-separated (e.g. sick;doença)",
      "name":         "Name",
      "protocol_name":"Protocol",
      "start_date":   "Start Date",
      "end_date":     "End Date",
      "current_day":  "Current Day",
      "predicted_iatf":"Predicted FTAI",
      "protocol_progress":    "Protocol Progress",
      "lot_protocol_section_title": "Tracking a Lot's Protocol",
      "lot_protocol_section_text":  "Assigning a plan below starts a new tracking cycle for this lot. Starting a new plan always ends whatever cycle is currently active.",
      "confirm_new_cycle_title":   "Start a new cycle?",
      "confirm_new_cycle_active_warning": "This will end the cycle currently in progress (started {{date}}) and start a new one.",
      "confirm_new_cycle_yes":     "Yes, Start Cycle",
      "no_active_protocol":   "No protocol assigned to this lot.",
      "start_tracking":       "Start Tracking Progress",
      "mark_step_complete":   "Mark Complete",
      "step_current":         "Current",
      "step_upcoming":        "Upcoming",
      "completed_on":         "Completed on",
      "completed_by_label":   "by",
      "protocol_history":     "Past Runs",
      "ended_on":             "Ended",
      "steps_completed":      "steps completed",
      "lot_prefix":    "REPRO",
      "weight_lot_prefix": "WEIGHT",
      "days_completed": "Days Completed",
      "notes":        "Notes",
      "language":     "Language",
      "message_type": "Type",
      "raw_message":  "Message",
      "direction":    "Direction",
      "source":       "Source",

      // Buttons
      "add_button":             "Add",
      "next_button":            "Next",
      "back_button":            "Back",
      "delete_error":           "Delete failed",
      "animal_added_success":   "Animal added successfully.",
      "bull_added_success":     "Bull added successfully.",
      "reproduction_duplicate_msg": "This animal is already in that lot.",

      // Reproduction
      "hide-protocol-view": "Hide Protocol View",
      "show-protocol-view": "Show Protocol View",
      "hide-notes-view":    "Hide Notes View",
      "show-notes-view":    "Show Notes View",
      "protocol_view":      "Protocol",
      "notes_view":         "Notes",
      "pregnancy-success-rate-by-lot":"Pregnancy Success Rate by Lot",
      "birth-rate-percentage":"Birth Rate Percentage",
      "bull_success_rate_chart":   "Pregnancy Success Rate by Bull / Breed",
      "group_by_bull":             "By Bull",
      "group_by_breed":            "By Breed",
      "chart_summary_best_bull":   "{{name}} achieved the highest pregnancy rate at {{percent}}%.",
      "chart_summary_no_bull_data":"No bull data recorded yet.",
      "success_rate_pct":          "Success Rate (%)",
      "chart_tooltip_success_fraction": "{{success}} of {{total}} succeeded",
      "protocol_success_rate_chart":   "Pregnancy Success Rate by Protocol",
      "chart_summary_best_protocol":   "{{name}} achieved the highest success rate at {{percent}}%.",
      "chart_summary_no_protocol_data":"No protocol data recorded yet.",
      "reproduction_results_chart_title": "Reproduction Results",
      "for_month":                 "for {{month}}",
      "chart_outcome_label_pregnant":         "are confirmed pregnant",
      "chart_outcome_label_returned_to_estrus": "returned to estrus this cycle",
      "chart_outcome_label_aborted":          "lost their pregnancy",
      "chart_outcome_label_calved_alive":     "gave birth successfully",
      "chart_outcome_label_calved_stillborn": "had a stillbirth",
      "chart_dam_died_note_singular": "You had 1 pregnant Dam die this month and she is not included in this chart result.",
      "chart_dam_died_note_plural":   "You had {{count}} pregnant Dams die this month and they are not included in this chart result.",

      "proceedure": "Procedure",

      // Breeds
      "angus":         "Angus",
      "brangus":       "Brangus",
      "cruzada":       "Cruzada",
      "nelore":        "Nelore",
      "sta_zelia":     "Sta. Zelia",
      "murrah":        "Murrah",
      "mediterrâneo":  "Mediterrâneo",
      "jafarabadi":    "Jafarabadi",
      "carabao":       "Carabao",
      "marchigiana":   "Marchigiana",
      "charolais":     "Charolais",
      "sindi":         "Sindi",
      "breed_type":        "Type",
      "breed_type_custom": "Custom",
      "breed_type_system": "System",

      // Death Causes
      "aborto":       "Aborto",
      "morreu":       "Morreu",
      "morto":        "Morto",
      "nasceu-morto": "Nasceu Morto",
      "natimorto":    "Natimorto",
      "natimortos":   "Natimortos",
      "viva":         "Viva",

      // Upload Steps
      "upload_select_file":    "Select CSV File",
      "upload_map_columns":    "Map Columns",
      "upload_map_columns_hint": "Match each data field to a column from your CSV.",
      "upload_map_values":     "Map Values",
      "upload_map_values_hint": "For dropdown fields, map your CSV values to expected values.",
      "upload_no_enum_fields": "No fields to map. All values look good.",
      "upload_review_submit":  "Review & Submit",
      "upload_records_count":  "{{count}} records will be uploaded to",
      "upload_column_mapping": "Column Mapping",
      "upload_preview":        "Preview (first 3 rows)",
      "upload_step_file":      "File",
      "upload_step_columns":   "Columns",
      "upload_step_values":    "Values",
      "upload_step_submit":    "Submit",
      "upload_skip":           "— skip —",
      "upload_select":         "— select —",
      "upload_uploading":      "Uploading...",
      "upload_upload":         "Upload",
      "upload_back":           "Back",
      "upload_next":           "Next",
      "upload_field":          "Field",
      "upload_csv_column":     "CSV Column",
      "upload_csv_value":      "CSV Value",
      "upload_maps_to":        "Maps To",
      "upload_skipped":        "skipped",
      "upload_default":        "default",
      "upload_failed":         "Upload failed",
      "upload_parse_error":    "Could not parse CSV headers.",
      "upload_desc_tag":       "The animal's ear tag",
      "upload_desc_dam":       "The dam's (mother's) ear tag",
      "upload_desc_breed":     "Breed of the animal",
      "upload_desc_sex":       "Sex of the animal",
      "upload_desc_area":      "Area/pasture name",
      "upload_desc_cause":     "Status of the animal",
      "upload_desc_date":      "Birth date (YYYY-MM-DD)",
      "upload_desc_is_alive":    "Whether the animal is alive (true/false). Defaults to true if not mapped.",
      "upload_desc_is_pregnant": "Whether the animal is pregnant (true/false). Defaults to false if not mapped.",
      "is_alive":              "Is Alive",
      "is_pregnant":           "Is Pregnant",
      "upload_desc_weight_tag":  "The animal's ear tag number",
      "upload_desc_weight_kg":   "Weight in kilograms",
      "upload_desc_weight_date": "Date of weighing (YYYY-MM-DD or DD/MM/YYYY)",

      // Notes
      "no_notes":             "No notes yet",
      "add_note":             "Add Note",
      "add_note_placeholder": "Write a note...",

      // Photos
      "photos":    "Photos",
      "no_photos": "No photos yet",

      // Calves
      "calves":               "Calves",
      "no_calves":            "No calves recorded",
      "loading":              "Loading",
      "male":                 "Male",
      "female":               "Female",
      "sex_not_set":          "Not Set",
      "animals_sex_not_set":  "Sex Not Set",
      "needs_attention":      "Needs Attention",

      // Profile
      "profile":          "Profile",
      "logout":           "Logout",
      "change_pref_lang": "Change your preferred language",
      "change_password":  "Change Password",

      // Lots
      "lots":                    "Lots",
      "lots_title":              "Reproduction Lots",
      "lot":                     "Lot",
      "lot_id":                  "Lot ID",
      "all_lots":                "All Lots",
      "select_lot":              "Select Lot",
      "animals_count":           "Animals",
      "animals_count_short":     "animals",
      "animal_count_singular":   "animal",
      "lot_count":               "Count",
      "view_animals":            "View Animals",
      "view_lot":                "View Lot",
      "add_lot":                 "Add Lot",
      "error_creating_lot":          "Error creating lot",
      "select_protocol":             "Select Protocol",
      "select_protocol_error":       "Please select a protocol",
      "repro_lot_name":              "Lot Name",
      "repro_lot_name_placeholder":  "e.g. Spring IATF 2026",
      "assign_protocol":         "Assign Protocol",
      "not_assigned":            "Not assigned",
      "change_protocol":         "Change Protocol",
      "no_animals_in_lot":       "No animals in this lot",
      "days_status":             "Days Status",

      // Bulls
      "bulls":                   "Bulls",
      "bull":                    "Bull",
      "bull_name":               "Bull Name",
      "bull_breed":              "Breed",
      "bull_tag":                "Ear Tag (optional)",
      "bull_tag_hint":           "If this bull is a known animal in your herd, enter his ear tag — his breed will be filled in and calves can show him as their Sire.",
      "bull_tag_hint_list":      "No ear tag on file for this bull yet. Add one in the Tag column above to start showing calves he's sired.",
      "select_bull":             "Select Bull",
      "sire":                    "Sire",
      "sired_calves":            "Calves Sired",
      "no_sired_calves":         "No calves recorded",
      "aliases":                 "WhatsApp Aliases",
      "alias":                   "WhatsApp Alias",
      "add_alias":               "Add Alias",
      "remove":                  "Remove",
      "add_bull":                "Add Bull",

      // Settings
      "default_protocol":          "Default Protocol",
      "default_protocol_settings":        "Default Reproduction Protocol",
      "default_protocol_hint":            "Assigned automatically when creating a reproduction lot via WhatsApp.",
      "default_herd_protocol_settings":   "Default General Plan",
      "default_herd_protocol_hint":       "Optionally assigned when creating a herd lot via WhatsApp.",
      "default_weight_protocol_settings": "Default Weight Plan",
      "default_weight_protocol_hint":     "Optionally assigned when creating a weight lot via WhatsApp.",
      "default_bull":              "Default Bull",
      "default_bull_settings":     "Default Bull for WhatsApp",
      "default_bull_hint":       "Set the default bull used when creating lots via WhatsApp messages.",
      "settings_saved":          "Settings saved successfully",
      "settings_save_error":     "Error saving settings",

      // Password Reset
      "current_password":        "Current Password",
      "password_changed_success": "Password changed successfully",
      "enter_verification_code": "Enter verification code",
      "email_sent_to":           "We sent an email to:",
      "enter_code_placeholder":  "Enter Code",
      "forgot_password_instructions": "Enter your email address and we'll send you a code to reset your password.",
      "send_reset_code":         "Send Reset Code",
      "reset_code_sent":         "A reset code has been sent to your email.",
      "enter_reset_code":        "Enter Reset Code",
      "enter_code_instructions": "Enter the 6-digit code sent to your email.",
      "verification_code":       "Verification Code",
      "verify_code":             "Verify Code",
      "verifying":               "Verifying...",
      "resend_code":             "Resend Code",
      "reset_password":          "Reset Password",
      "new_password":            "New Password",
      "confirm_new_password":    "Confirm New Password",
      "passwords_do_not_match":  "Passwords do not match",
      "phone_number_required":   "Phone number is required",
      "password_too_short":      "Password must be at least 6 characters",
      "password_reset_success":  "Password reset successfully! Redirecting to login...",
      "back_to_login":           "Back to Login",
      "back":                    "Back",
      "mark_done":               "Mark done",
      "undo":                    "Undo",
      "clear_filter":            "Clear filter",
      "automatic":               "Automatic",

      // WhatsApp Message Samples — Page Header
      "samples_page_title": "WhatsApp Message Samples",

      // WhatsApp Message Samples — Herd (Births & Deaths)
      "samples_births_description":       "Register animal births with tag, sex, and breed. Optionally include an area name on the last line.",
      "samples_deaths_description":       "Register animal deaths by tag and cause. Updates existing birth records.",
      "samples_sep_simple_births":        "Example 1: Simple births",
      "samples_sep_births_with_area":     "Example 2: With area",
      "samples_sep_calf_with_dam":        "Example 3: Calf with dam",
      "samples_sep_death_causes":         "Death causes",
      "samples_deaths_user_input":        "2235 sickness\n2236 accident\n2237 slaughtered",
      "samples_births_response_1":        "Zap Manejo detected birth data. We added 3 births to area unknown.",
      "samples_births_response_2":        "Zap Manejo detected birth data. We added 2 births to area Fazenda Norte.",
      "samples_births_response_3":        "Zap Manejo detected birth data. We added 2 births to area unknown.",
      "samples_deaths_response":          "Zap Manejo detected death data. We added 3 deaths.",
      "samples_birth_format_title":       "Birth Format Reference:",
      "samples_birth_format_regular":      "Regular birth (e.g., 12345 m nelore)",
      "samples_birth_format_code_regular": "tag sex breed",
      "samples_birth_format_calf_en":      "Calf entry in English",
      "samples_birth_format_code_calf_en": "calf dam sex breed",
      "samples_birth_format_calf_pt":      "Calf entry in Portuguese",
      "samples_birth_format_code_calf_pt": "bezerro dam sex breed",
      "samples_birth_format_calf_f":       "Female calf in Portuguese",
      "samples_birth_format_code_calf_f":  "bezerra dam sex breed",
      "samples_sex_values_label":         "Sex Values:",
      "samples_sex_values":               "m (male), f (female)",
      "samples_breeds_label":             "Breeds:",
      "samples_breeds_list":              "angus, nelore, brangus, cruzada, murrah, sta.zelia, and more",
      "samples_death_causes_label":       "Death Causes:",
      "samples_death_causes_list":        "slaughtered, sickness (or: sick, doença), accident (or: acidente), old age, other — or any custom cause from Ranch Settings",

      // WhatsApp Message Samples — Climate
      "samples_rain_description":         "Record rainfall data with date and amount in millimeters. Optionally add an area on its own last line, or a registered area at the end of a line.",
      "samples_temp_description":         "Record temperature data with date and value in Celsius. Optionally add an area on its own last line, or a registered area at the end of a line.",
      "samples_weather_title":            "Weather Query",
      "samples_weather_description":      "Get current weather for any location.",
      "samples_weather_keywords":         "weather, climate",
      "samples_sep_rainfall":             "Rainfall entries",
      "samples_sep_temperature":          "Temperature entries",
      "samples_sep_weather":              "Weather lookup",
      "samples_rain_response":            "Zap Manejo detected precipitation data. We added 77 mm of rain.",
      "samples_temp_response":            "Zap Manejo detected temperature data. We added temperature data from the last 3 days.",
      "samples_sep_climate_with_area":    "With area",
      "samples_rain_area_response":       "Zap Manejo detected precipitation data. We added 55 mm of rain to area Fazenda Norte.",
      "samples_temp_area_response":       "Zap Manejo detected temperature data. We added 1 temperature to area Fazenda Norte.",
      "samples_climate_format_title":     "Format Reference:",
      "samples_climate_format_rain":          "Rainfall (e.g., 15/03 25mm)",
      "samples_climate_format_code_rain":     "dd/mm amount mm [area]",
      "samples_climate_format_temp":          "Temperature (e.g., 15/03 32C)",
      "samples_climate_format_code_temp":     "dd/mm temp C [area]",
      "samples_climate_format_weather":       "Weather query",
      "samples_climate_format_code_weather":  "weather for location",

      // WhatsApp Message Samples — Weight
      "samples_weight_description":       "Record animal weights with tag and weight in kilograms.",
      "samples_sep_basic_weight":         "Basic weight entry",
      "samples_sep_weight_space":         "With space before kg",
      "samples_sep_weight_date":          "With optional date",
      "samples_sep_weight_multiple":      "Multiple entries",
      "samples_weight_response_1":        "Zap Manejo recorded weight data. We added 1 weight entry totaling 500 kg.",
      "samples_weight_response_2":        "Zap Manejo recorded weight data. We added 3 weight entries totaling 1550 kg.",
      "samples_weight_format_title":      "Format Reference:",
      "samples_weight_format_basic":           "Basic format (e.g., 1234, 500kg)",
      "samples_weight_format_code_basic":      "tag, weight kg",
      "samples_weight_format_date":            "With optional date (e.g., 1234, 500kg 15/03)",
      "samples_weight_format_code_date":       "tag, weight kg dd/mm",
      "samples_weight_format_no_comma":        "Without comma (e.g., 1234 500kg)",
      "samples_weight_format_code_no_comma":   "tag weight kg",
      "samples_weight_keyword_note":           "The kg suffix identifies weight messages.",
      "samples_weight_lot_title":              "Weight with Lot Assignment",
      "samples_weight_lot_description":        "Record a weight and assign the animal to a specific weight lot in one message.",
      "samples_sep_weight_lot_enroll":         "Enroll animal + record weight",
      "samples_sep_weight_lot_existing":       "Already enrolled — just update weight",
      "samples_sep_weight_lot_date":           "With optional date",
      "samples_weight_lot_response_enroll":    "Tag 1234 enrolled in WEIGHT-0001. Weight 500 kg recorded.",
      "samples_weight_lot_response_existing":  "Weight 520 kg recorded for tag 1234 in WEIGHT-0001.",
      "samples_weight_format_lot":             "Assign to lot and record weight (e.g., WEIGHT-0001 1234 500kg)",
      "samples_weight_format_code_lot":        "WEIGHT-XXXX tag weight kg",
      "samples_weight_format_lot_date":        "With optional date (e.g., WEIGHT-0001 1234 500kg 15/03)",
      "samples_weight_format_code_lot_date":   "WEIGHT-XXXX tag weight kg dd/mm",
      "samples_keyword_label":            "Keyword:",
      "keywords_label":                   "Keywords:",

      // WhatsApp Message Samples — Reproduction
      "samples_create_lot_title":         "Create New Lot",
      "samples_create_lot_description":   "Start a new FTAI lot using your default protocol. Optionally specify a bull.",
      "samples_add_animals_title":        "Add Animals to Lot",
      "samples_add_animals_description":  "Add animal tags to an existing lot. Optionally specify a bull per animal.",
      "samples_lot_status_title":         "Check Lot Status",
      "samples_lot_status_description":   "Query the current status and tasks for a lot.",
      "samples_sep_lot_default_bull":     "Create lot (default bull)",
      "samples_sep_lot_specific_bull":    "Create lot with specific bull",
      "samples_sep_lot_bull_next_line":   "Bull on next line",
      "samples_sep_add_default_bull":     "Add animals (use lot's bull)",
      "samples_sep_add_specific_bull":    "With specific bulls per animal",
      "samples_sep_status_query":         "Status query",
      "samples_add_animals_response_1":   "Added 3 animals to lot FTAI-0042.",
      "samples_add_animals_response_2":   "Added 3 animals to lot FTAI-0042.",
      "samples_repro_format_creating_title":  "Creating Lots:",
      "samples_repro_format_new_lot":         "new lot - Uses default protocol and default bull",
      "samples_repro_format_new_lot_bull":    "new lot jabriel - Uses default protocol with bull \"jabriel\"",
      "samples_repro_format_novo_lote":       "novo lote + newline + touro - Bull on next line",
      "samples_repro_format_adding_title":    "Adding Animals:",
      "samples_repro_format_animal_default":  "12345 - Uses the lot's default bull",
      "samples_repro_format_animal_bull":     "12345 angus - Uses bull \"angus\" for this animal",
      "samples_repro_format_iatf_title":      "FTAI Reference Formats:",
      "samples_repro_format_iatf_examples":   "FTAI-0001, FTAI 0001, FTAI0001, ftai-42",
      // Finance Samples
      "samples_finance_gain_title":           "Recording Income",
      "samples_finance_gain_description":     "Use the 'gain' keyword followed by an amount, category, optional notes, and optional date.",
      "samples_finance_keywords_gain":        "gain",
      "samples_sep_finance_simple_gain":      "Simple gain entry",
      "samples_finance_msg_gain_simple":      "gain 1500 animal sale",
      "samples_finance_gain_response_1":      "✅ 1 financial entry recorded\n+ R$1,500.00 — Animal Sale",
      "samples_sep_finance_gain_institution": "Gain with institution",
      "samples_finance_msg_gain_institution": "gain 1500 animal sale farm credit",
      "samples_finance_gain_response_4":      "✅ 1 financial entry recorded\n+ R$1,500.00 — Animal Sale · Farm Credit",
      "samples_sep_finance_gain_notes":       "Gain with institution and notes",
      "samples_finance_msg_gain_notes":       "gain 800 labor cash fence repair",
      "samples_finance_gain_response_2":      "✅ 1 financial entry recorded\n+ R$800.00 — Labor · Cash\n  fence repair",
      "samples_sep_finance_gain_date":        "Gain with institution and date",
      "samples_finance_msg_gain_date":        "gain 2500 animal sale bank 15/03",
      "samples_finance_gain_response_3":      "✅ 1 financial entry recorded\n+ R$2,500.00 — Animal Sale · Bank · 15/03",
      "samples_finance_loss_title":           "Recording Expenses",
      "samples_finance_loss_description":     "Use the 'loss' keyword followed by an amount, category, optional notes, and optional date.",
      "samples_finance_keywords_loss":        "loss",
      "samples_sep_finance_simple_loss":      "Simple loss entry",
      "samples_finance_msg_loss_simple":      "loss 200 feed",
      "samples_finance_loss_response_1":      "✅ 1 financial entry recorded\n- R$200.00 — Feed",
      "samples_sep_finance_loss_institution": "Loss with institution",
      "samples_finance_msg_loss_institution": "loss 200 feed cash",
      "samples_finance_loss_response_4":      "✅ 1 financial entry recorded\n- R$200.00 — Feed · Cash",
      "samples_sep_finance_loss_notes":       "Loss with institution and notes",
      "samples_finance_msg_loss_notes":       "loss 350 veterinary credit card vaccination",
      "samples_finance_loss_response_2":      "✅ 1 financial entry recorded\n- R$350.00 — Veterinary · Credit Card\n  vaccination",
      "samples_sep_finance_loss_date":        "Loss with institution and date",
      "samples_finance_msg_loss_date":        "loss 150 fuel cash 20/03",
      "samples_finance_loss_response_3":      "✅ 1 financial entry recorded\n- R$150.00 — Fuel · Cash · 20/03",
      "samples_finance_project_title": "Tracking a Project",
      "samples_finance_project_description": "Name a project anywhere in a finance message, by its nickname or code, and the entry counts toward it. Every reply shows the project's updated balance.",
      "samples_sep_finance_project_expense": "Expense for a project",
      "samples_finance_msg_project_expense": "loss 1200 equipment corral",
      "samples_finance_project_response_expense": "✅ 1 financial entry recorded\n- R$1,200.00 — Equipment · PROJ-0001\n\n📁 *PROJ-0001 — Corral repair*\nAlso known as: corral\nBalance: −R$2,000.00 🔴",
      "samples_sep_finance_project_flip": "Income that turns the balance positive",
      "samples_finance_msg_project_flip": "gain 3000 other corral scrap sale",
      "samples_finance_project_response_flip": "✅ 1 financial entry recorded\n+ R$3,000.00 — Other · PROJ-0001\n  scrap sale\n\n📁 *PROJ-0001 — Corral repair*\nAlso known as: corral\nBalance: R$1,000.00 🟢\n🎉 Back in the positive",
      "samples_finance_format_title":              "Message Format:",
      "samples_finance_format_gain":               "record a gain (income)",
      "samples_finance_format_code_gain":          "gain amount category",
      "samples_finance_format_loss":               "record a loss (expense)",
      "samples_finance_format_code_loss":          "loss amount category",
      "samples_finance_format_institution":        "optional institution (bank, cash, etc.)",
      "samples_finance_format_code_institution":   "gain amount category institution",
      "samples_finance_format_notes":              "everything after institution is treated as notes",
      "samples_finance_format_code_notes":         "gain amount category institution notes",
      "samples_finance_format_date":               "optional date defaults to today",
      "samples_finance_format_code_date":          "gain amount category institution dd/mm",
      "samples_finance_categories_label":          "Categories:",
      "samples_finance_categories_list":           "animal sale, animal purchase, labor, feed, veterinary, equipment, fuel, other",
      "samples_finance_institutions_label":   "Institutions:",
      "samples_finance_institutions_list":    "cash, bank, farm credit, credit card, check, other",
      // Lists samples
      "samples_lists_description":            "Create lists, add items and check a list via WhatsApp. LIST or LISTA both work.",
      "samples_sep_lists_create":             "Create a list",
      "samples_lists_create_user_input":      "new list Store",
      "samples_lists_create_response":        "✅ *LIST-0003 — Store created*\n\nTo add items:\nLIST-0003\nitem1\nitem2",
      "samples_sep_lists_add_default":        "Add to default list",
      "samples_sep_lists_add_specific":       "Add to specific list",
      "samples_sep_lists_query":              "Query list status",
      "samples_lists_add_response":           "✓ milk added to LIST-0001 Weekly Shopping.",
      "samples_lists_alias_title":            "By name or alias",
      "samples_lists_alias_description":      "A list's name or any of its WhatsApp aliases (set on the list's page) works in place of its code, with or without LIST in front.",
      "samples_sep_lists_alias_add":          "Add by alias",
      "samples_lists_alias_add_input":        "hardware nails",
      "samples_lists_alias_add_response":     "✓ nails added to LIST-0002 Hardware Run.",
      "samples_sep_lists_alias_keyword":      "With LIST in front",
      "samples_lists_alias_keyword_input":    "LIST hardware screws, glue",
      "samples_lists_alias_keyword_response": "✓ 2 items added to LIST-0002 Hardware Run.",
      "samples_sep_lists_alias_query":        "Query by name",
      "samples_lists_alias_query_input":      "Hardware Run",
      "samples_lists_alias_query_response":   "LIST-0002\nHardware Run\nAliases: hardware\nCreated by: Mark\n\nActive\n❌ Nails\n❌ Screws\n❌ Glue",
      "samples_sep_lists_alias_status":       "Mark by alias",
      "samples_lists_alias_status_input":     "purchased hardware nails $20",
      "samples_lists_alias_status_response":  "✅ nails marked as purchased (LIST-0002 Hardware Run) · $20.00",
      "samples_lists_format_alias":           "a list's name or alias works anywhere LIST-0001 does",
      "samples_lists_item":                   "milk",
      "samples_lists_query_response":         "LIST-0001\nWeekly Shopping\nAliases: shopping\nCreated by: Mark\n\nActive\n❌ Milk\n❌ Eggs\n✅ Bread",
      "samples_lists_format_title":           "Format Reference",
      "samples_lists_format_add":             "add item to default list",
      "samples_lists_format_specific":        "add item to specific list",
      "samples_lists_format_query":           "query list status and items",
      "samples_lists_format_create":          "create a list (name optional)",
      "samples_lists_format_status":          "mark an item purchased / completed / pending, by name; optional cost ($150); LIST without a number = default list",
      "samples_lists_status_title":           "Mark items",
      "samples_lists_status_description":     "Change an item's status by its name on the list. An exact name wins; otherwise every word you type must start a word of the item. With a cost on a list linked to a project, the expense is recorded.",
      "samples_sep_lists_status_match":       "One match (with cost)",
      "samples_lists_status_match_input":     "purchased LIST-0003 fence wire $150",
      "samples_lists_status_match_response":  "✅ fence wire marked as purchased (LIST-0003 Hardware store) · $150.00\nExpense recorded in the list's project.",
      "samples_sep_lists_status_ambiguous":   "More than one match",
      "samples_lists_status_ambiguous_input": "LIST-0003 purchased wire",
      "samples_lists_status_ambiguous_response": "More than one item matches on LIST-0003 Hardware store: fence wire, wire cutters. Please be more specific.",
      "samples_sep_lists_status_nomatch":     "No match",
      "samples_lists_status_nomatch_input":   "purchased LIST-0003 shoes",
      "samples_lists_status_nomatch_response": "No matching items on LIST-0003 Hardware store.\nItems you can mark as purchased: salt, mineral salt, coarse salt, wire cutters, nails 2 inch, nails 3 inch",
      "samples_sep_lists_status_undo":        "Undo",
      "samples_lists_status_undo_input":      "pending LIST-0003 fence wire",
      "samples_lists_status_undo_response":   "✅ fence wire marked as pending (LIST-0003 Hardware store) · $150.00",

      // Tier 2 feature summary samples
      "samples_finance_summary_description":       "Get a summary of income and expenses over the last 30 days.",
      "samples_finance_summary_response":          "*Finances — Last 30 Days*\n\n*Income:* +8500 (6)\n*Expenses:* -3200 (4)\n*Net:* +5300",
      "samples_weight_summary_description":        "Get a summary of all active weight lots.",
      "samples_weight_summary_response":           "*Weight Lots — 2 active*\n\nWEIGHT-0001 — Spring Batch: 48 animals _(default)_\nWEIGHT-0002 — New Arrivals: 12 animals",
      "samples_repro_summary_description":         "Get a summary of all IATF lots and animal counts.",
      "samples_repro_summary_response":            "*Reproduction — 2 lot(s)*\n\nREPRO-0001: 24 animals\n  Births: 18\n  Aborts: 2\n  Failures to conceive: 3\n  Dam deaths: 1\n  Success rate: 78%\n\nREPRO-0002: 18 animals\n  Births: 15\n  Aborts: 1\n  Failures to conceive: 2\n  Dam deaths: 0\n  Success rate: 83%",
      "samples_lists_summary_description":         "Get a summary of all active lists.",
      "samples_lists_summary_response":            "*Lists — 3 active*\n\nLIST-0001 — Weekly Shopping (shopping): 5 items\nLIST-0002 — Hardware Run (hardware): 2 items\nLIST-0003 — Ranch Provisions: 8 items\n\n📝 Commands:\n\nTo add to the default list:\nLIST {item}\n\nTo add to a specific list:\nLIST-0001 {item}\n\nTo view a specific list:\nLIST-0001\n\nTo mark an item as purchased:\npurchased LIST-0001 {item}\n\nA list's name or alias works in place of LIST-0001.",
      "samples_finance_summary_user_input":        "finances",
      "samples_weight_summary_user_input":         "weight",
      "samples_repro_summary_user_input":          "reproduction",
      "samples_lists_summary_user_input":          "lists",

      // Overview samples
      "samples_overview_tab":                 "Overview",
      "samples_overview_description":         "Get a full ranch snapshot — herd, team, active lots, this month's rain and finances.",
      "samples_overview_response":            "*Zap Manejo — Overview*\n\n*Herd:* 342 animals\n*Team:* 5 members\n*Messages:* 1204\n\n*IATF Lots:* 3\n*Active Weight Lots:* 2\n\n*Rain in May:* 47mm\n*Finances in May:* +5200 / -1800",
      "samples_overview_user_input":          "overview",

      // Ranch samples
      "samples_ranch_tab":                        "Ranches",
      "samples_ranch_list_title":                 "Ranch List",
      "samples_ranch_list_description":           "View your current active ranch and all available ranches with their switch commands.",
      "samples_ranch_list_response":              "🏡 Ranch Summary\n\nCurrent ranch: Terpstra Ranch\n\nYour ranches:\n• Terpstra Ranch — switch: ranch terp\n• South Pasture Ranch — switch: ranch south\n\nSend \"ranch [nickname]\" to switch your active ranch.",
      "samples_ranch_switch_title":               "Switch Ranch",
      "samples_ranch_switch_description":         "Switch your active ranch by sending its nickname.",
      "samples_sep_ranch_switch":                 "Switching to a different ranch",
      "samples_ranch_switch_response":            "✅ Your active ranch is now: South Pasture Ranch",
      "samples_sep_ranch_already_active":         "Already on that ranch",
      "samples_ranch_already_active_response":    "ℹ️ Terpstra Ranch is already your active ranch.",
      "samples_ranch_format_title":               "Format",
      "samples_ranch_format_list":                "Show your current ranch and all available ranches",
      "samples_ranch_format_switch":              "Switch to the ranch with this nickname",
      "samples_ranch_user_input":                 "ranch",
      "samples_ranch_switch_user_input":          "ranch terp",

      // Help samples
      "samples_help_tab":                     "Help",
      "samples_help_general_description":     "Get a quick reference of all supported WhatsApp commands.",
      "samples_help_feature_description":     "Get detailed format reference for a specific feature.",
      "samples_help_general_response":        "*Zap Manejo — Commands*\n\n🐄 *Herd*\n  12345 m nelore — birth\n  12345 sickness — death\n  herd — herd summary\n\n📋 *Lists*\n  LIST item — add to the default list\n  LIST-0001 item — add to a list\n  LIST-0001 — query list\n  purchased LIST-0001 item — mark as purchased\n\n⚖️ *Weight*\n  1234, 500kg — record weight\n  WEIGHT-0001 1234 500kg — assign to lot\n\n🌧️ *Climate*\n  15/03 25mm — rainfall\n  15/03 32C — temperature\n  weather for location — forecast\n\n💰 *Finances*\n  gain 500 category — income\n  loss 200 category — expense\n\n🔬 *Reproduction*\n  new lot — create IATF lot\n  IATF-0001 — lot status\n\n_Type_ *help <topic>* _for details_\n_e.g._ weight, herd, lists, finances, climate, reproduction",
      "samples_help_weight_response":         "*Weight — Format Reference*\n\nRecord weight:\n  1234, 500kg\n  1234, 500kg 15/03\n  1234 500kg\n\nWeight lots:\n  WEIGHT-0001 1234 500kg\n  WEIGHT-0001 1234 500kg 15/03\n  WEIGHT-0001 — lot summary\n  WEIGHT-0001 -3 — feed score\n\nKeyword: kg",
      "samples_help_user_input":              "help",
      "samples_help_weight_user_input":       "help weight",

      // Billing
      "billing":                    "Billing",
      "next_billing":               "Next billing",
      "billing_success_msg":        "Your subscription is now active. Welcome aboard!",
      "billing_cancel_msg":         "Subscription not completed. You can subscribe anytime from the Billing page.",
      "manage_billing":             "Manage subscription",

      // Billing — herd-size bands (2026-10)
      "billing_free_title":            "Free plan",
      "billing_free_desc":             "Up to {{max}} animals. Calves under 8 months don't count.",
      "billing_free_current":          "You're on the free plan.",
      "billing_choose_band":           "Choose a plan by the size of your herd",
      "billing_interval_month":        "Monthly",
      "billing_interval_year":         "Annual",
      "billing_annual_note":           "Pay for 10 months, get 12 — 2 months free",
      "billing_price_month":           "{{price}}/month",
      "billing_price_year":            "{{price}}/year",
      "billing_price_unavailable":     "—",
      "billing_subscribe":             "Subscribe",
      "billing_recommended":           "Recommended for your herd",
      "billing_enterprise_title":      "Enterprise plan",
      "billing_enterprise_desc":       "From {{min}} animals. We'll put together a plan tailored to your operation.",
      "billing_contact_us":            "Contact us",
      "contact_us":                    "Contact us",
      "contact_us_section_title":      "Talk to us",
      "contact_us_section_text":       "Questions about your herd, your plan or how to get started? Message us on WhatsApp for the fastest reply, or write a note and we'll answer by email.",
      "contact_whatsapp_title":        "Chat with us on WhatsApp",
      "contact_whatsapp_text":         "Message us directly in the app you already use every day. A real person answers — no call center.",
      "contact_whatsapp_button":       "Open WhatsApp",
      "contact_whatsapp_prefill":      "Hello ZapManejo — I need help with my account.",
      "contact_email_title":           "Send a message",
      "contact_email_text":            "Prefer to write? Fill in the form below and we'll reply by email.",
      "contact_message_label":         "Message",
      "contact_message_placeholder":   "How can we help with your operation?",
      "contact_context_note":          "We'll include your account and ranch ({{ranch}}) so we can find you.",
      "contact_sent_title":            "Message sent.",
      "contact_sent_text":             "Thanks for getting in touch — we'll reply by email soon. In a hurry? Message us on WhatsApp for the fastest reply.",
      "contact_send_another":          "Send another message",
      "contact_name_invalid":          "Tell us your name.",
      "contact_email_invalid":         "That email looks wrong.",
      "contact_phone_invalid":         "That phone number is too long.",
      "contact_message_too_short":     "A little more detail helps us help you.",
      "contact_message_too_long":      "That message is too long. Please shorten it.",
      "contact_rate_limited":          "You've sent several messages recently. Please try again in a little while, or use WhatsApp.",
      "contact_send_failed":           "Something went wrong sending your message. Please try again or write to us on WhatsApp.",
      "billing_current_plan":          "Current plan",
      "billing_current_badge":         "Your plan",
      "billing_billed_month":          "Billed monthly",
      "billing_billed_year":           "Billed annually",
      "billing_change_plan_note":      "To change plan or billing period, use Manage subscription.",
      "billing_payment_problem_title": "Payment problem",
      "billing_payment_problem":       "There's a problem with the payment for your {{band}} plan. Update your payment method in Manage subscription to continue.",
      "billing_active_plan":           "Active plan",
      "billing_active_plan_desc":      "Your account has an active plan with access to every feature.",
      "billing_load_error":            "Couldn't load the plans. Try again later.",
      "billing_error_generic":         "Couldn't start the checkout. Try again.",
      // API error codes from POST /api/billing/checkout and GET /api/billing/plans.
      // Keys match the codes exactly: Fetch (Utils.js) translates {"error": code} by key.
      "invalid_request":               "Invalid request. Reload the page and try again.",
      "invalid_band":                  "Invalid plan. Reload the page and choose again.",
      "invalid_interval":              "Invalid billing period. Choose monthly or annual.",
      "free_plan_no_checkout":         "The free plan doesn't need a payment.",
      "enterprise_contact_us":         "For a herd that size, contact us for a tailored plan.",
      "already_subscribed":            "You already have a subscription. To change plans, use Manage subscription.",
      "price_not_configured":          "This plan isn't available for purchase yet. Contact us.",
      "stripe_unavailable":            "We couldn't reach the payment system. Try again in a few minutes.",

      // i18n PT Coverage Phase 1 (Mode A + C — recon 2026-04-27)
      "unit_kg":                    "kg",
      "tag_number_placeholder":     "Tag Number",
      "add_to_specific_lot":        "Add to specific lot?",
      "use_default_lot":            "Use default lot",
      "tag_and_lot_required":       "Tag and lot are required.",
      "error_saving":               "Error saving. Please try again.",
      "phone_format_us":            "1-xxx-xxx-xxxx",
      "phone_format_br":            "xx-xx-xxxxx-xxxx",
      "rainfall_placeholder":       "Rainfall in mm",
      "temperature_placeholder":    "Temperature (Celsius)",
      "repro_status_unknown":       "Unknown",
      "repro_status_completed":     "Completed",
      "repro_status_due_today":     "Due Today",
      "repro_status_missed":        "Missed",
      "repro_status_pending":       "Pending",
      "repro_status_not_completed": "Not Completed",
      "no_actions_for_step":        "No actions defined for this step yet",
      "error_user_not_found":       "User not found",
      "error_no_phone_numbers":     "No phone numbers available. Please contact support.",
      "samples_weather_user_input":           "weather for Jupiter FL",
      "samples_weather_response":             "Zap Manejo Weather:\nAddress: Jupiter, FL 33458, USA\nTime: 2026-02-18T14:30:00\nCondition: Partly Cloudy\nTemperature: 28.5 °C\nPrecipitation: 10% Light Rain",
      "samples_lot_specific_bull_user_input": "new lot angus",
      "samples_lot_specific_bull_response":   "Zap Manejo created a lot using protocol 'Standard Protocol'.\n*REPRO-0043*\n\nStart Date: 2026-02-18 (Day 0)\nBull: Angus Prime\n\nDay 0 Tasks:\n- Insert implant\n- Inject GnRH\n\nYou can add animals to this lot through the dashboard.",
      "samples_lot_status_user_input":        "REPRO-0042",
      "samples_lot_status_response":          "🔬 *REPRO-0042 — North Field*\nTagged: 22\nStart Date: 2026-08-01\nDay: 12\n\n📋 Protocol: Standard 9-Day CO-Synch + CIDR\nStep 3 of 5:\n  · Remove CIDR\n  · Give PGF2α injection\nReply \"REPRO-0042 done\" when complete.\n\n📝 Commands:\n\nTo add animals to lot:\nREPRO-0042 {tag1} {tag2} ...\n\nBirths: 18\nAborts: 2\nFailures to conceive: 1\nDam deaths: 1\nSuccess rate: 86%",

      // i18n PT Coverage Phase 2 (recon 2026-04-29)
      "age_months":                  "months",
      "age_years":                   "years",
      "language_portuguese":         "Portuguese",
      "language_english":            "English",
      "pagination_rows_per_page":    "Rows per page:",
      "pagination_range_separator":  "of",
      "pagination_select_all":       "All",
      "reproduction_result":         "Result",
      "repro_result_choose":         "-- Choose a Result --",
      "males_cannot_be_added_to_reproduction_lot":          "Only female animals can be added to a reproduction lot.",
      "only_female_animals_can_have_reproduction_outcome":  "Only female animals can have a reproduction outcome recorded.",
      "bull_tag_not_found":                                 "No animal found with that ear tag.",
      "bull_tag_not_male":                                  "That ear tag belongs to a female animal — a bull's tag must be male.",
      "upload_choose_file":          "Choose a CSV file:",
      "upload_button":               "Upload",
      "transaction_amount":          "Amount",
      "column_type":                 "Type",
      "type":                        "Type",
      "header_subtitle":             "Web Dashboard",
      "change_successful":           "Change Successful",
      "birth_duplicate_error":       "Birth with that tag already exists.",
      "death_duplicate_error":       "Death with that tag already exists.",
      "zootecnista":                 "Zootecnista",
      "agronomo":                    "Agronomist",
      "institution_other":           "Other",
      "institution_cash":            "Cash",
      "institution_bank":            "Bank",
      "institution_farm_credit":     "Farm Credit",
      "institution_credit_card":     "Credit Card",
      "institution_check":           "Check",
    }
  },
  pt: {
    translation: {

      // Login/Registration
      "login":            "Conecte-se",
      "register":         "Cadastre-se",
      "forgot_password":  "Esqueceu sua senha",
      "email":            "E-mail",
      "password":         "Senha",
      "username":         "Nome de usuário",
      "confirm_password": "Confirme sua senha",
      "password_requirements": "A senha deve conter pelo menos 8 caracteres, uma letra maiúscula, uma letra minúscula, um número e um caractere especial.",

      // Header Values
      "dashboard":     "Painel da Web",
      "home":          "Início",
      "filters":       "Filtros",
      "reset_filters":   "Limpar Filtros",
      "done":            "Concluído",
      "all_time":        "Todo período",
      "this_month":      "Este mês",
      "last_3_months":   "Últimos 3 meses",
      "last_year":       "Último ano",

      // Tab Buttons
      "overview":      "Visão Geral",
      "births":        "Rebanho",
      "deaths":        "Mortes",
      "rain":          "Chuvas",
      "temperatures":  "Temperaturas",
      "areas":         "Áreas",
      "breeds":        "Raças",
      "unknown":       "Desconhecida",
      "reproduction":  "Reprodução",
      "team":          "Equipe",
      "charts":        "Gráficos",
      "corral_manager": "ZM Curral",
      "messages":      "Mensagens",
      "whatsapp":      "WhatsApp",
      "protocols":     "Protocolos",
      "plans":         "Planos",
      "animals":       "Animais",
      "ranch_settings": "Config. Fazenda",
      "climate":        "Clima",
      "log":            "Suas Mensagens",
      "samples":        "Exemplos",
      "try_it":         "Envie mensagens daqui",
      "phone_number":   "Número de Telefone",

      // Try It
      "try_it_title":       "Envie mensagens daqui",
      "settings":           "Configurações",
      "try_it_description": "Envie uma mensagem a partir daqui. As mensagens serão salvas na sua conta.",
      "try_it_placeholder": "Digite sua mensagem aqui...\n\nExemplo:\n12345 m nelore\n12346 f angus",
      "try_it_empty":       "Envie uma mensagem para ver a resposta",
      "try_it_no_match":    "Mensagem não reconhecida. Confira a aba Exemplos para formatos válidos.",
      "try_it_error":       "Erro ao processar mensagem",

      // Phone Number
      "phone_number_title":       "Seu Número de WhatsApp",
      "phone_number_description": "Este é o número dedicado do ZapManejo para sua conta. Seus membros de equipe podem enviar mensagens WhatsApp para este número para registrar dados da fazenda.",
      "reveal_phone_number":      "Revelar Número de Telefone",
      "phone_number_error":       "Não foi possível obter o número de telefone. Por favor, tente novamente.",

      "send":               "Enviar",
      "sending":            "Enviando...",
      "clear":              "Limpar",
      "select_date":        "Selecionar data (opcional)",

      // Overview Screen
      "overview_title":       "Visão Geral",
      "total_herd":           "Rebanho Total",
      "total_team_members":   "Membros da Equipe",
      "total_custom_breeds":  "Raças Personalizadas",
      "total_bulls":          "Touros",
      "total_messages":       "Mensagens Processadas",
      "whatsapp_usage":       "Uso do WhatsApp",
      "total_areas":          "Áreas totais",
      "active_reproduction_lots": "Lotes de Reprodução",
      "active_weight_lots":       "Lotes de Peso",
      "active_lists":             "Listas Ativas",
      "none": "Nenhum",

      // Weight
      "weight":               "Peso",
      "weight_kg":            "Peso (kg)",
      "weight_data":          "Dados de Peso",
      "weight_chart":         "Gráfico de Peso",
      "weight_charts":        "Gráficos de Peso",
      "weights_by_tag":       "Pesos por Brinco",
      "weight_lots":          "Lotes",
      "slaughter_predict_tab": "Previsão de Abate",
      "slaughter_tab":        "Abate",

      // Slaughter tab
      "slaughter_section_title":   "Registros de Abate",
      "slaughter_section_text":    "Registre os resultados do frigorífico após o processamento do lote. Capture o rendimento de carcaça e a quantidade de animais para encerrar o lote e comparar os resultados reais com as projeções.",
      "slaughter_record_title":    "Registrar Abate",
      "slaughter_abattoir":        "Nome do Frigorífico",
      "slaughter_yield_pct":       "Rendimento de Carcaça %",
      "slaughter_animal_count":    "Quantidade de Animais",
      "slaughter_record_button":   "Salvar Registro",
      "slaughter_history":         "Histórico de Abates",
      "slaughter_yield_chart_title": "Rendimento de Carcaça por Lote",
      "slaughter_yield_chart_sub":   "Barras verdes estão na média ou acima. Barras vermelhas estão abaixo.",
      "avg_yield":                   "Rendimento Médio",
      "best_yield":                  "Melhor Rendimento",
      "industry_avg":                "Média do setor",
      "no_slaughter_records":        "Nenhum registro de abate com dados de rendimento ainda.",
      "slaughter_record_success":  "Registro de abate salvo.",
      "slaughter_record_error":    "Erro ao salvar. Por favor, tente novamente.",
      "col_lot_code":              "Lote",
      "col_abattoir":              "Frigorífico",
      "col_animal_count":          "Animais",
      "col_yield_pct":             "Rendimento %",

      "avg_current_weight":   "Peso Médio Atual",
      "lot_avg_weight_chart_label": "Peso médio de todos os animais neste lote ao longo do tempo",
      "lot_session_weight_chart_label": "Peso registrado do lote ao longo do tempo",
      "proj_target_date":     "Projetar até Data",
      "proj_target_weight":   "Projetar até Peso",
      "proj_by_date_label":   "Projetado",
      "proj_by_weight_label": "Projetado",
      "adg_column":           "GPD Médio",
      "days_to_target":       "Dias para o Alvo",
      "predict_date":         "Prev. Pronto",
      "ready_for_slaughter":  "✓ Pronto",
      "enrolled_at":          "Cadastrado em",
      "days_on_feed":         "Dias em Confinamento",
      "first_weigh_date":     "Data 1ª Pesagem",
      "first_weigh_value":    "1º Peso",
      "last_weigh_date":      "Data Última Pesagem",
      "last_weigh_value":     "Último Peso",
      "latest_weight":        "Último Peso",
      "total_weigh_ins":      "Pesagens",
      "no_weigh_ins":         "Nenhuma pesagem registrada.",
      "last_weigh_in":        "Última Pesagem",
      "sessions":             "Sessões",
      "select_weight_lot":    "Selecionar lote de peso...",
      "all_weight_lots":      "Todos os lotes de peso",
      "enroll_animal":        "Adicionar Animal ao Lote",
      "weight_active_section_title": "Animais em Lotes de Peso",
      "weight_active_section_text":  "Animais matriculados em lotes de peso ativos. Filtre por brinco ou lote para ver o progresso individual.",
      "weight_animals_section_title": "Gerencie o Peso do Seu Jeito",
      "weight_animals_section_text":  "Acompanhe o peso do seu rebanho de 3 formas flexíveis.\n\n🐄 Por Animal — registre o peso de cada animal e calculamos o GMD e o progresso automaticamente.\n⚖️ Por Peso do Lote — registre simplesmente o peso médio do lote ao longo do tempo, sem precisar pesar individualmente.\n📊 Por Pontuação — use seu próprio sistema de notas (ex: -3 a +3) para avaliar a condição do lote de forma rápida.\n\nCombine os métodos em qualquer lote.",
      "weight_lots_section_title":   "Lotes de Peso",
      "weight_lots_section_text":    "Lotes de peso são grupos de animais cujo peso está sendo acompanhado. Você pode registrar o peso individualmente por animal ou acompanhar o peso do lote com uma pontuação simples.",

      // Weight lot expanded panel
      "weightSessions":       "Pesos do Lote",
      "noWeighIns":           "Nenhuma pesagem registrada ainda.",
      "lotNotes":             "Notas",
      "noNotes":              "Nenhuma nota ainda.",
      "writeNote":            "Escrever uma nota...",
      "adding":               "Adicionando...",
      "addNote":              "Adicionar Nota",
      "locationHistory":      "Histórico de Localização",
      "currentLocation":      "Localização Atual",
      "noLocation":           "Não definida",
      "select_location":      "Selecionar Localização",
      "locationName":         "Localização",
      "locationPlaceholder":  "ex: Pasto 3",
      "moveDate":             "Data",
      "recordMove":           "Adicionar",
      "noMoves":              "Sem histórico de localização ainda.",
      "current":              "Atual",
      "default_weight_lot":      "Lote de Peso Padrão",
      "default_weight_lot_hint": "Quando uma pesagem é recebida via WhatsApp e o animal ainda não está em um lote, ele será automaticamente adicionado a este lote.",
      "default_weight_lot_section_title": "Lote de Peso Padrão",
      "default_weight_lot_section_text":  "Defina um lote padrão para cadastro automático via WhatsApp quando nenhum lote for especificado.",
      "weight_lot_name":             "Nome do Lote",
      "weight_lot_name_placeholder": "ex: Ciclo Verão 2025",
      "tracking_method_question":      "Como você vai acompanhar o peso deste lote?",
      "tracking_method_required_hint": "Escolha uma opção — isso define quais seções aparecem na página do lote.",
      "tracking_method_animal":            "Por Animal",
      "tracking_method_animal_desc":       "Acompanhe pesagens individuais por animal com brinco, com peso alvo e GMD.",
      "tracking_method_lot_average":       "Média do Lote",
      "tracking_method_lot_average_desc":  "Acompanhe um único peso médio do lote inteiro ao longo do tempo.",
      "tracking_method_score":             "Escore Corporal",
      "tracking_method_score_desc":        "Acompanhe o escore de condição corporal do lote em vez do peso na balança.",
      "tracking_method_combination":       "Combinação",
      "tracking_method_combination_desc":  "Use mais de um método — mostra todas as seções neste lote.",
      "target_weight_optional":        "Peso Alvo (kg, opcional)",
      "adg_estimate_optional":         "GMD Estimado (kg/dia, opcional)",
      "lot_plan_optional":           "Plano (opcional)",
      "no_plan":                     "Sem plano",
      "weight_lot_code":             "Código do Lote",
      "median_lot_weight":           "Peso de Entrada (kg)",
      "mlw_note":                    "Peso médio dos animais ao entrar neste lote.",
      "adg_label":                   "Ganho Diário Esperado (kg/dia)",
      "adg_note":                    "Sua estimativa de quantos kg cada animal ganha por dia. Usado para prever a data de abate até que dados reais de pesagem estejam disponíveis.",
      "adg_calculated_label":        "GPD (Calculado)",
      "adg_estimated_label":         "GPD (Sua Estimativa)",
      "target_weight":               "Peso Alvo",
      "target_weight_note":          "O peso em que os animais são considerados prontos para o abate.",
      "lot_weight_progress":         "Progresso de Peso do Lote",
      "select_lot_to_view":          "Selecione um lote para ver o gráfico",
      "est_today":                   "Est. Hoje",
      "of_target":                   "do alvo",
      "projected_target":            "Alvo Projetado",
      "rename_lot":                  "Renomear Lote",
      "rename_lot_note":             "Dê um nome amigável para identificar este lote mais facilmente.",
      "rename_lot_placeholder":      "ex: Ciclo Verão 2026",
      "estimated_exit_date":         "Prev. Saída",
      "lot_target_weight":           "Peso Alvo (kg)",
      "lot_target_weight_note":      "O peso em que os animais deste lote são considerados prontos para o abate.",
      "lot_created_at":              "Data de Início",
      "lot_color":                   "Cor",
      "system_assigned":             "atribuído pelo sistema",
      "auto_assigned":               "atribuído automaticamente",
      "mlw_required":                "O peso de entrada é obrigatório.",
      "head_count_required":         "A quantidade de animais é obrigatória.",
      "error_creating_weight_lot":   "Erro ao criar lote. Tente novamente.",

      // Lot detail page
      "lot_scores":              "Pontuações",
      "last_score_short":        "Última",
      "score_value":             "Pontuação",
      "no_scores":               "Nenhuma pontuação registrada.",
      "add_score":               "Adicionar Pontuação",
      "wat_send_via_whatsapp":   "Enviar pelo WhatsApp:",
      "wat_add_animal":          "Adicionar animal",
      "wat_record_score":        "Registrar pontuação",
      "wat_query_lot":           "Consultar lote",
      "wat_shorthand":           "Atalho (sem código de lote)",
      "wat_add_animals":         "Adicionar animais",
      "wat_default_set":         "Lote padrão atualizado",
      "wat_copy":                "Copiar",
      "wat_protocol_start":      "Iniciar rastreamento",
      "wat_protocol_done":       "Marcar etapa atual como concluída",
      "wat_protocol_stop":       "Parar rastreamento",
      "wat_list_default_set":    "Lista padrão atualizada",
      "wat_add_list_item":       "Adicionar item",
      "wat_query_list":          "Consultar lista",
      "wat_list_shorthand":      "Atalho (lista padrão)",
      "wat_list_item_example":   "produto",
      "wat_list_created":        "criada",
      "wat_list_mark_purchased": "Marcar como comprado",
      "wat_list_purchased_keyword": "comprei",
      "end_feed_lot":            "Encerrar Lote / Registrar Abate",
      "slaughter_info":          "Registro de Abate",
      "scored_at":               "Registrado Em",
      "samples_weight_lot_score_title":        "Pontuação do Lote",
      "samples_weight_lot_score_description":  "Registrar pontuação de arraçoamento",
      "samples_weight_lot_score_response":     "✅ Pontuação -3 registrada para PESO-0005 (Confinamento A).",
      "last_weigh_in_short":  "Última",
      "notes_label":          "notas",
      "animal_weigh_ins":     "Pesagens por Animal",
      "no_animals":           "Nenhum animal cadastrado",
      "archive_lot":          "Arquivar Lote",
      "unarchive_lot":        "Reativar Lote",
      "target_reached":       "Peso alvo atingido!",
      "archive_suggestion":   "Considere arquivar este lote agora que os animais estão prontos para o abate.",
      "archive_confirm":      "Tem certeza que deseja arquivar este lote?",
      "lot_status_active":    "Ativo",
      "lot_status_archived":  "Arquivado",

      "role":                 "Função",
      "status":               "Status",
      "owner":                "Proprietário",
      "manager":              "Gerente",
      "messenger":            "Mensageiro",
      "active":               "Ativo",
      "pending":              "Pendente",
      "select_role":          "Selecionar função...",
      "send_invite":          "Enviar Convite",
      "invite_sent":          "Convite enviado com sucesso",
      "invite_error":         "Erro ao enviar convite",
      "error_user_exists":    "Já existe um usuário com este e-mail",
      "error_adding_team":    "Erro ao adicionar membro",
      "billing_owner_only":    "Apenas o proprietário da conta pode fazer alterações no faturamento e assinaturas.",
      "role_feature_dashboard": "Acesso ao dashboard",
      "role_feature_billing": "Gerenciamento de cobrança",
      "role_feature_data":    "Entrada e gestão de dados",
      "role_feature_whatsapp": "Mensagens via WhatsApp",
      "start_weight":         "Peso Inicial",
      "end_weight":           "Peso Final",
      "weight_gained":        "Ganho de Peso",
      "weight_over_time":     "Peso ao Longo do Tempo",
      "select_animals":       "Selecionar Animais",
      "enter_tag_number":     "Digite o número do brinco",
      "select_animals_to_display": "Selecione animais para exibir o gráfico",

      // Chart summaries
      "chart_summary_herd_by_breed":    "{{percent}}% do seu rebanho é {{breed}}.",
      "chart_summary_no_herd_data":     "Nenhum animal registrado ainda.",
      "other_breeds":                   "Outras raças",
      "chart_summary_top_cause":        "A causa de morte mais comum é {{cause}} ({{percent}}%).",
      "chart_summary_no_deaths":        "Nenhuma morte registrada.",
      "other_causes":                   "Outras causas",
      "chart_summary_age_range":        "{{count}} animais com idade entre 7 e 12 meses.",
      "chart_summary_no_age_data":      "Nenhum animal nessa faixa etária.",
      "chart_summary_repro_this_month": "{{count}} animais acompanhados este mês — {{result}} é o resultado mais comum.",
      "chart_summary_no_repro_month":   "Sem dados de reprodução para este mês.",
      "chart_summary_best_lot":         "{{lot}} atingiu o maior sucesso de prenhez com {{percent}}%.",
      "chart_summary_no_repro_data":    "Nenhum dado de reprodução registrado ainda.",
      "chart_summary_rainfall":         "{{total}}mm de chuva no total. Mês mais chuvoso: {{month}} ({{amount}}mm).",
      "chart_summary_no_rainfall":      "Nenhum dado de chuva registrado.",
      "chart_summary_temperature":      "Temperatura média em {{month}} foi {{temp}}°C.",
      "chart_summary_no_temperature":   "Nenhum dado de temperatura registrado.",
      "chart_summary_weight_tracking":  "Acompanhando peso de {{count}} animais.",
      "chart_summary_no_weight_data":   "Nenhum dado de peso registrado.",
      "chart_summary_finance_profit":      "{{amount}} líquido nos últimos 12 meses.",
      "chart_summary_finance_month":       "{{gains}} de entrada, {{losses}} de saída este mês.",
      "chart_summary_finance_institution": "{{institution}} tem o maior saldo líquido: {{amount}}.",
      "chart_summary_no_finance_data":     "Nenhum dado financeiro registrado ainda.",

      // Charts
      "select_chart":         "Selecionar Gráfico",
      "herd_by_breed":        "Rebanho por raça",
      "herd_by_cause_of_death": "Mortes por Causa",
      "rainfall_by_month":    "Precipitação por Mês",
      "total_rainfall_by_month": "Precipitação Total por Mês",
      "rainfall_mm":          "Precipitação Total (mm)",
      "temperature_by_month": "Temperatura média por mês",
      "temperature_celsius":  "Temperatura (°C)",
      "month":                "Mês",
      "reproduction_recent":  "Resultados Recentes de Reprodução",
      "reproduction_success": "Sucesso de Reprodução por Grupo",
      "all":                  "Todos",
      "age_category":         "Bezerros desmamando do leite",
      "seven_months":         "7 meses",
      "eight_months":         "8 meses",
      "nine_months":          "9 meses",
      "ten_twelve_months":    "10-12 meses",
      "pregnant":             "Prenha",
      "returned_to_estrus":   "Retornou ao Cio",
      "aborted":              "Abortada",
      "calved_alive":         "Parto (Vivo)",
      "calved_stillborn":     "Parto (Natimorto)",
      "dam_died":              "Matriz Morreu",

      // Screen Titles
      "births_title":      "Nascimentos",
      "births_add":        "Adicionar Nascimento",
      "deaths_title":      "Mortes",
      "deaths_add":        "Adicionar Mortes",
      "rainfall_title":    "Chuvas",
      "rainfall_add":      "Adicionar Chuvas",
      "temperature_title": "Temperaturas",
      "temperature_add":   "Adicionar Temperatura",
      "areas_title":       "Áreas",
      "area_add":          "Adicionar Área",
      "team_title":        "Equipe",
      "team_add":          "Adicionar membro da Equipe",

      // Protocols
      "description":           "Descrição",
      "duration":              "Duração",
      "target_animals":        "Animais Alvo",
      "protocol_type":         "Tipo",
      "protocol_type_system":  "Sistema",
      "protocol_type_custom":  "Personalizado",
      "add_protocol":          "Adicionar Protocolo",
      "add_plan":              "Adicionar Plano",
      "edit_plan":             "Editar Plano",
      "save_plan":             "Salvar Plano",
      "update_plan":           "Atualizar Plano",
      "add_herd_plan":         "Adicionar Plano de Rebanho",
      "edit_herd_plan":        "Editar Plano de Rebanho",
      "add_weight_plan":       "Adicionar Plano de Peso",
      "edit_weight_plan":      "Editar Plano de Peso",
      "select_plan":           "Selecionar Plano",
      "assign_plan":           "Atribuir Plano",
      "change_plan":           "Alterar Plano",
      "no_active_plan":        "Nenhum plano atribuído a este lote.",
      "plan_progress":         "Progresso do Plano",
      "lot_plan_section_title": "Acompanhamento de Plano do Lote",
      "plan_name":             "Plano",
      "error_creating_plan":   "Erro ao criar plano",
      "error_updating_plan":   "Erro ao atualizar plano",
      "system_plan_readonly":  "Este é um plano do sistema e não pode ser editado.",
      "basic_info":            "Informações Básicas",
      "timeline":              "Cronograma",
      "day":                   "Dia",
      "to":                    "Até",
      "days":                  "dias",
      "days_label":            "Dias",
      "event":                 "Evento",
      "event_placeholder":     "O que acontece neste dia?",
      "treatments":            "Tratamentos",
      "medication":            "Medicamento",
      "device":                "Dispositivo",
      "procedure":             "Procedimento",
      "add_treatment":         "Adicionar Tratamento",
      "add_action":                        "Adicionar Ação",
      "action_placeholder":                "O que o operador deve verificar? (ex: verificar carrapatos, retirar implante)",
      "attach_action":                     "+ Anexar ação",
      "create_action":                     "Adicionar Nova Ação",
      "step_note":                         "Nota (dose, marca, variação, etc.)",
      "step_note_herd":                    "Nota (produto, dose, instruções)",
      "step_note_weight":                  "Nota (instruções)",
      "step_note_placeholder_herd":        "Instruções opcionais para esta etapa, ex: \"Vacina clostridial, 5 mL subcutânea\"",
      "step_note_placeholder_weight":      "Instruções opcionais para esta etapa, ex: \"Pesar antes da alimentação\"",
      "action_placeholder_herd":           "O que o operador deve fazer? (ex: vacinar, vermifugar, verificar carrapatos)",
      "action_placeholder_weight":         "O que o operador deve fazer? (ex: pesar, avaliar condição corporal)",
      "step_note_placeholder":             "Texto instrucional opcional para esta etapa, ex: \"1,0 mL para novilhas, 2,0 mL para vacas\"",
      "add_timeline_day":                  "Adicionar Dia ao Cronograma",
      "add_step":                          "Adicionar Etapa",
      "add_step_note":                     "Adicionar Nota",
      "no_steps_in_phase":                 "Nenhuma etapa adicionada.",
      "phase_pre_insemination":            "Pré-Inseminação",
      "phase_pre_insemination_hint":       "Etapas antes da inseminação, como hormônios, vitaminas ou preparo dos animais.",
      "phase_insemination":                "Inseminação",
      "phase_insemination_hint":           "O evento de inseminação em si e qualquer procedimento no mesmo dia.",
      "phase_post_insemination":           "Pós-Inseminação",
      "phase_post_insemination_hint":      "Etapas após a inseminação, incluindo verificação de prenhez e registro de resultados.",
      "system_action_mark_all_pregnant":              "Deixar o sistema marcar todos os animais como prenhos",
      "system_action_mark_all_pregnant_tooltip_title": "⚙️ Ação do Sistema",
      "system_action_mark_all_pregnant_tooltip":       "O ZapManejo irá automaticamente marcar todos os animais como prenhos neste dia.",
      "system_action_notify_birthing_window":              "Deixar o sistema avisar a equipe que a janela de partos começou",
      "system_action_notify_birthing_window_tooltip_title": "⚙️ Ação do Sistema",
      "system_action_notify_birthing_window_tooltip":       "O ZapManejo enviará um aviso à equipe neste dia informando que a janela de partos deste lote começou. Nenhuma alteração de status — apenas informativo.",
      "system_action_mark_lost_pregnancies":              "Deixar o sistema marcar animais que não pariram como prenhez perdida",
      "system_action_mark_lost_pregnancies_tooltip_title": "⚙️ Ação do Sistema",
      "system_action_mark_lost_pregnancies_tooltip":       "O ZapManejo irá marcar qualquer animal que não tenha parido até este dia como prenhez perdida e avisará a equipe com a lista de animais afetados. Animais já marcados como vazios, ou que já pariram, não são alterados.",
      "system_action_mark_lot_archived":              "Deixar o sistema arquivar este lote",
      "system_action_mark_lot_archived_tooltip_title": "⚙️ Ação do Sistema",
      "system_action_mark_lot_archived_tooltip":       "O ZapManejo irá automaticamente arquivar este lote neste dia, encerrando o acompanhamento do protocolo e liberando todos os animais matriculados para um novo ciclo. Você pode sempre arquivá-lo manualmente antes pelo menu de Status do lote.",
      "protocol_missing_archive_step_nudge": "Este protocolo não termina com uma etapa de arquivamento — lotes criados a partir dele não serão arquivados automaticamente. Você ainda pode salvar, ou adicionar uma etapa Arquivar Lote no último dia.",
      "saving":                "Salvando...",
      "save":                  "Salvar",
      "saved":                 "Salvo ✓",
      "account":               "Conta",
      "ranches":               "Fazendas",
      "ranch":                 "Fazenda",
      "ranch_name":            "Nome da Fazenda",
      "address":               "Endereço",
      "setup_welcome_title":         "Bem-vindo ao ZapManejo!",
      "setup_welcome_subtitle":      "Vamos configurar sua primeira fazenda para começar.",
      "ranch_details_section_title": "Detalhes da Fazenda",
      "ranch_details_section_text":  "Defina o nome e o endereço desta fazenda. O nome aparece na barra lateral e nos relatórios.",
      "ranch_nickname_placeholder":  "Apelido no WhatsApp (ex: terpstra)",
      "ranch_nickname_hint":         "Apelido curto usado no WhatsApp para mudar de fazenda — ex: envie \"fazenda terpstra\" para mudar para esta fazenda.",
      "ranches_section_title": "Fazendas",
      "ranches_section_text":  "Gerencie as fazendas da sua conta. Cada fazenda tem seu próprio rebanho, pesagem, reprodução e registros financeiros.",
      "save_protocol":         "Salvar Protocolo",
      "edit_protocol":         "Editar Protocolo",
      "update_protocol":       "Atualizar Protocolo",
      "error_creating_protocol": "Erro ao criar protocolo",
      "error_updating_protocol": "Erro ao atualizar protocolo",
      "system_protocol_readonly": "Este é um protocolo do sistema e não pode ser editado.",
      "cancel":                "Cancelar",
      "cows":                  "Vacas",
      "heifers":               "Novilhas",

      // Lists
      "lists":                     "Listas",
      "lists_list":                "Lista",
      "lists_item_count":          "Itens",
      "lists_all":                 "Listas",
      "lists_categories":          "Categorias",
      "list_prefix":               "LISTA",
      "lists_all_section_title":        "Listas",
      "lists_all_section_text":         "Gerencie as listas do rancho. Adicione itens pelo WhatsApp com LISTA (ex.: LISTA sal) ou por aqui.",
      "lists_categories_section_title": "Categorias das Listas",
      "lists_categories_section_text":  "Gerencie as categorias das listas. As categorias ajudam a organizar e ordenar os itens para impressão.",
      "lists_item":                     "Item",
      "lists_added_by":                 "Adicionado Por",
      "lists_filter_pending":           "Pendente",
      "lists_filter_all":               "Todos",
      "lists_filter_active":            "Ativos",
      "lists_filter_archived":          "Arquivados",
      "lists_filter_both":              "Ambos",
      "lists_all_lists":                "Todas as Listas",
      "lists_unarchive":                "Desarquivar Lista",
      "lists_expires_at":               "Encerra",
      "lists_no_expiry":                "Sem data de encerramento",
      "lists_expires_placeholder":      "Data de encerramento (opcional)",
      "lists_status_pending":           "Pendente",
      "lists_status_purchased":         "Comprado",
      "lists_status_completed":         "Concluído",
      "lists_cost":                     "Custo",
      "lists_cost_optional":            "Custo (opcional)",
      "lists_no_cost_hint":             "Sem custo informado: nenhuma despesa é registrada no projeto.",
      "lists_completed_hint":           "Itens concluídos nunca registram despesa. Use Comprado para registrar o custo.",
      "lists_project":                  "Projeto",
      "lists_no_project":               "Não vinculada a um projeto",
      "lists_link_project":             "Vincular a projeto",
      "lists_project_hint":             "Itens comprados com custo viram despesas neste projeto.",
      "lists_project_link_error":       "Não foi possível vincular o projeto.",
      "edit":                           "Editar",
      "lot_projects_optional":          "Projetos (opcional)",
      "lot_no_project":                 "Não vinculado a nenhum projeto",
      "lot_project_none_yet":           "Ainda não há projetos ativos. Crie um em Finanças → Projetos para acompanhar os custos deste lote.",
      "lot_project_hint":               "Despesas e receitas marcadas neste projeto contam para ele. Um lote pode estar em vários projetos, e um projeto pode abranger vários lotes.",
      "lot_project_link_error":         "Não foi possível vincular o projeto.",
      "lot_project_unlink_error":       "Não foi possível remover o projeto.",
      "lists_items":                    "Itens",
      "lists_done":                     "Feitos",
      "lists_done_of":                  "{{done}} de {{total}}",
      "lists_spent":                    "Gasto",
      "lists_aliases_placeholder":      "ex.: loja; ferragem",
      "lists_finance_category_default": "Outros (categoria padrão)",
      "project_not_active":             "Esse projeto está encerrado.",
      "invalid_list_item":              "Item inválido: confira o nome, o status e o custo.",
      "lists_no_lists":                 "Não há registros para exibir.",
      "lists_new":                      "Nova Lista",
      "lists_name_placeholder":         "Nome da lista (opcional)",
      "lists_create":                   "Criar",
      "lists_set_default":              "★ Definir como Padrão",
      "lists_archive":                  "Arquivar Lista",
      "lists_archive_confirm":          "Confirmar Arquivamento",
      "lists_no_items":                 "Nenhum item encontrado.",
      "lists_print":                    "Imprimir",
      "lists_select_list":              "Selecionar lista",
      "lists_item_placeholder":         "Descrição do item",
      "lists_no_category":              "Sem categoria",
      "lists_save":                     "Salvar Alterações",
      "lists_item_saved":               "Item salvo.",
      "lists_item_save_error":          "Erro ao salvar item. Tente novamente.",
      "lists_delete_item":              "Excluir Item",
      "lists_delete_confirm":           "Toque para confirmar exclusão",
      "lists_item_delete_error":        "Erro ao excluir item. Tente novamente.",

      // Finances
      "finances":                  "Finanças",
      "transactions":              "Transações",
      "finance_charts":            "Gráficos Financeiros",
      "finance_settings":          "Finanças",
      "gain":                      "Receita",
      "loss":                      "Despesa",
      "gains":                     "Receitas",
      "losses":                    "Despesas",
      "category":                  "Categoria",
      "categories":                "Categorias",
      "finance_categories":        "Categorias Financeiras",
      "animal_sale":               "Venda Animal",
      "animal_purchase":           "Compra Animal",
      "labor":                     "Mão de Obra",
      "feed":                      "Ração",
      "veterinary":                "Veterinário",
      "equipment":                 "Equipamento",
      "fuel":                      "Combustível",
      "other":                     "Outros",
      "other_categories":          "Outras categorias",
      "currency":                  "Moeda",
      "currency_brl":              "Real Brasileiro (R$)",
      "currency_usd":              "Dólar Americano ($)",

      // Section descriptions
      "herd_section_title": "Rebanho",
      "herd_section_text":  "Seu registro completo de animais. Cada registro representa um animal identificado por um número de brinco. Os registros são criados automaticamente quando sua equipe envia mensagens de nascimento pelo WhatsApp, ou você pode adicioná-los e enviá-los manualmente aqui.",

      "herd_animals_section_title": "Animais do Rebanho",
      "herd_animals_section_text":  "Seu registro completo de animais. Cada registro representa um animal identificado por um número de brinco.",
      "herd_lots_section_title":    "Lotes de Rebanho",
      "herd_lots_section_text":     "Agrupe animais em lotes para acompanhar localização e movimentação. Envie \"novo lote rebanho\" pelo WhatsApp ou adicione um aqui.",
      "herd_plans_section_title":    "Planos",
      "herd_plans_section_text":     "Planos gerais que podem ser atribuídos a lotes de rebanho.",
      "herd_settings_section_title": "Configurações",
      "herd_settings_section_text":  "Configure os padrões usados ao criar lotes de rebanho pelo WhatsApp.",

      "herd_lots":                  "Lotes",
      "herd_lot_prefix":            "REBANHO",
      "select_herd_lot":            "Selecionar lote de rebanho",
      "herd_lot_code":              "Código do Lote",
      "herd_lot_name":              "Nome do Lote",
      "herd_lot_name_placeholder":  "ex: Pasto Norte",
      "error_creating_herd_lot":    "Erro ao criar lote de rebanho. Tente novamente.",
      "no_herd_lots":               "Nenhum lote de rebanho ainda.",
      "wat_add_animals_to_lot":     "Adicionar animais (brinco, sexo, raça por linha)",
      "created":                    "criado",

      // Ranch Settings section descriptions
      "team_section_title":     "Membros da Equipe",
      "team_section_text":      "Cadastre os números de WhatsApp que podem enviar dados para a sua fazenda. O número de cada membro é associado à sua conta ao receber uma mensagem. Proprietários e gerentes podem adicionar registros; mensageiros só podem enviar dados. Cada membro da equipe é atribuído a uma única fazenda — ao enviar dados via WhatsApp, os dados inseridos ou retornados serão da fazenda atribuída.",
      "areas_section_title":    "Áreas da Fazenda",
      "areas_section_text":     "Defina os pastos e piquetes da sua fazenda. Adicione apelidos no WhatsApp para facilitar o envio de mensagens — por exemplo, digite \"p1\" e será registrado como \"Pasto 1\".",
      "breeds_section_title":   "Raças do Rebanho",
      "breeds_section_text":    "Defina as raças do seu rebanho. Adicione apelidos no WhatsApp para digitar mais rápido — por exemplo, \"nel\" será reconhecido como \"Nelore\" ao registrar nascimentos ou pesagens.",
      "death_causes_section_title":  "Causas de Morte",
      "death_causes_section_text":   "Defina os motivos pelos quais um animal pode morrer. Causas padrão são fornecidas pelo sistema. Adicione causas personalizadas específicas da sua fazenda.",
      "death_causes":                "Causas de Morte",
      "death_cause":                 "Causa de Morte",
      "Slaughtered":                 "Abatido",
      "Sickness":                    "Doença",
      "Accident":                    "Acidente",
      "Old Age":                     "Velhice",
      "Other":                       "Outra",
      "death":                       "Morte",
      "alive":                       "Vivo",
      "dead":                        "Morto",
      "mark_as_dead":                "Marcar este animal como morto",
      "all_causes":                  "Todas as Causas",
      "all_statuses":                "Todos os Status",
      "all_pregnant":                "Qualquer Status de Gestação",
      "not_pregnant":                "Não Prenha",
      "select_cause":                "Selecionar Causa",
      "system_record_no_delete":     "Registros do sistema não podem ser excluídos.",
      "currency_section_title": "Moeda de Exibição",
      "currency_section_text":  "Defina a moeda usada para exibir os dados financeiros no painel. Isso afeta como os valores são formatados nos relatórios e gráficos.",

      "locations_section_title": "Localizações da Fazenda",
      "locations_section_text":  "Defina localizações nomeadas na sua fazenda — piquetes, pastos, campos. Adicione apelidos no WhatsApp para que os membros usem atalhos ao registrar movimentações de lote.",
      "locations":               "Localizações",
      "lot_fields":                   "Campos de Lote",
      "lot_fields_section_title":     "Campos Personalizados de Lote",
      "lot_fields_section_text":      "Defina campos de metadados personalizados que aparecem em todos os lotes — rebanho, peso e reprodução. Cada campo tem um nome amigável e apelidos para WhatsApp.",
      "lot_custom_fields":            "Campos Personalizados",
      "lot_custom_fields_empty":      "Nenhum campo personalizado definido ainda.",
      "lot_custom_field_value_empty": "Não definido",
      "add_lot_field":                "Adicionar Campo",
      "lot_field_friendly_name":      "Nome do Campo",
      "lot_field_db_key":             "Chave do Campo",
      "lot_field_aliases":            "Apelidos no WhatsApp",
      "lot_field_aliases_hint":       "Separe múltiplos apelidos com ponto e vírgula. ex: contagem;count",
      "lot_field_type_system":        "Sistema",
      "lot_field_type_custom":        "Personalizado",
      "tagged_animals":               "Animais Marcados",
      "location_name":           "Nome da Localização",
      "location_name_placeholder": "ex: Pasto Norte",
      "no_locations":            "Nenhuma localização definida ainda.",

      // WhatsApp section descriptions
      "whatsapp_samples_section_title": "Formatos de Mensagem",
      "whatsapp_samples_section_text":  "Veja os formatos de mensagem WhatsApp que sua equipe pode usar para registrar dados da fazenda. Envie de qualquer número cadastrado para registrar nascimentos, pesagens, clima e muito mais.",
      "whatsapp_tryit_section_title":   "Envie mensagens daqui",
      "whatsapp_tryit_section_text":    "Digite uma mensagem no formato WhatsApp para ver exatamente como o sistema irá analisá-la e armazená-la. Use isso para verificar os formatos antes de compartilhá-los com sua equipe.",
      "whatsapp_log_section_title":     "Histórico de Mensagens",
      "whatsapp_log_section_text":      "Todas as mensagens WhatsApp recebidas dos números cadastrados da sua equipe, incluindo como cada uma foi interpretada e armazenada.",
      "whatsapp_phone_section_title":   "Seu Número de WhatsApp",
      "whatsapp_phone_section_text":    "O número WhatsApp dedicado da sua fazenda. Compartilhe com sua equipe para que saibam para onde enviar as mensagens.",

      // Climate section descriptions
      "rain_section_title":         "Registros de Chuva",
      "rain_section_text":          "Acompanhe a precipitação diária na sua fazenda. Os registros são adicionados automaticamente quando sua equipe envia medições de chuva pelo WhatsApp.",
      "temperatures_section_title": "Registros de Temperatura",
      "temperatures_section_text":  "Acompanhe as leituras diárias de temperatura. Os registros são adicionados automaticamente quando sua equipe envia medições de temperatura pelo WhatsApp.",

      // Reproduction section descriptions
      "repro_lots_section_title":             "Lotes de Reprodução",
      "repro_lots_section_text":              "Agrupe animais em lotes para gerenciar protocolos de reprodução em conjunto. Cada lote registra a data de início, o protocolo utilizado e o touro.",
      "repro_active_section_title":           "Animais Ativos",
      "repro_active_section_text":            "Visualize e atualize o status reprodutivo dos animais atualmente em um lote. Registre resultados após diagnósticos de gestação e avaliações finais.",
      "repro_protocols_section_title":        "Protocolos",
      "repro_protocols_section_text":         "Defina os protocolos de IATF utilizados na sua fazenda. O protocolo padrão é pré-selecionado ao criar um novo lote — use \"Definir como padrão\" para alterá-lo.",
      "repro_bulls_section_title":            "Touros",
      "repro_bulls_section_text":             "Gerencie os touros utilizados para monta natural ou como reprodutores nos protocolos de IA. O touro padrão é pré-selecionado ao criar um novo lote — use \"Definir como padrão\" para alterar.",
      "repro_settings_section_title":         "Configurações",
      "repro_settings_section_text":          "Configure os padrões usados ao criar lotes de reprodução pelo WhatsApp.",
      "protocol_not_available":               "Detalhes do protocolo indisponíveis.",

      // Weight section descriptions
      "weight_bytag_section_title":  "Peso por Brinco",
      "weight_bytag_section_text":   "Consulte o histórico completo de pesagens de qualquer animal pelo número do brinco. Acompanhe o progresso individual ao longo do tempo.",
      "weight_charts_section_title": "Gráficos de Peso",
      "weight_charts_section_text":  "Visão geral visual do progresso de ganho de peso por lote e resultados de rendimento de carcaça do frigorífico.",
      "individual_animal_weights":   "Pesos Individuais por Animal",
      "estimated_weight":            "Estimado",
      "actual_weight":               "Real",
      "projected_actual":            "Projeção (GPD Real)",
      "weight_data_section_title":   "Registros de Peso",
      "weight_data_section_text":    "Todas as pesagens individuais do rebanho. Os registros são adicionados automaticamente quando sua equipe envia leituras de peso pelo WhatsApp.",
      "weight_plans_section_title":   "Planos",
      "weight_plans_section_text":    "Planos de manejo de peso que podem ser atribuídos a lotes de peso.",
      "weight_settings_section_title": "Configurações",
      "weight_settings_section_text":  "Configure os padrões usados ao criar lotes de peso pelo WhatsApp.",

      // Finance section descriptions
      "finance_transactions_section_title": "Transações",
      "finance_transactions_section_text":  "Registre e revise todas as transações financeiras — receitas (ganhos) e despesas (perdas) — organizadas por data, categoria e instituição.",
      "finance_projects_section_title":  "Projetos",
      "finance_projects_section_text":   "Acompanhe se um projeto está dando lucro ou prejuízo. Vincule lançamentos a um projeto e o saldo é somado sozinho: escolha o projeto no lançamento, ou cite o projeto numa mensagem financeira do WhatsApp, ex: \"gasto 1200 cimento curral\".",
      "projects":                  "Projetos",
      "project_code":              "Código",
      "project_balance":           "Saldo",
      "project_income":            "Receitas",
      "project_expenses":          "Despesas",
      "project_status_active":     "Ativo",
      "project_status_closed":     "Encerrado",
      "project_name_placeholder":  "Nome do projeto, ex: Reforma do curral",
      "project_nicknames_placeholder": "Apelidos para o WhatsApp, ex: curral;cerca (opcional)",
      "all_projects":              "Todos os projetos",
      "no_projects":               "Nenhum projeto ainda. Adicione um para acompanhar o saldo.",
      "no_project_transactions":   "Nenhum lançamento neste projeto ainda.",
      "project_list_summary":      "{{done}} de {{total}} feitos",
      "project_not_found":         "Projeto não encontrado.",
      "close_project":             "Encerrar projeto",
      "reopen_project":            "Reabrir projeto",
      "delete_project":            "Excluir projeto",
      "delete_project_confirm":    "Excluir este projeto? Os lançamentos são mantidos; só deixam de pertencer a um projeto.",
      "project_tip_title":         "Lance neste projeto pelo WhatsApp",
      "lot_tip_title":             "Enviar para este lote pelo WhatsApp",
      "list_tip_title":            "Use esta lista pelo WhatsApp",
      "project_tip_expense":       "Uma despesa",
      "project_tip_income":        "Uma receita",
      "project_tip_expense_keyword": "gasto",
      "project_tip_income_keyword":  "receita",
      "project_name_required":     "O projeto precisa de um nome.",
      "invalid_project_status":    "Status de projeto inválido.",
      "project":                   "Projeto",
      "no_project":                "Sem projeto",
      "balance_by_project":        "Saldo por projeto",
      "project_balance_over_time": "Saldo ao longo do tempo",
      "project_day_change":        "No dia",
      "chart_summary_projects":    "{{positive}} no positivo, {{negative}} no negativo.",
      "chart_summary_projects_shown": "Mostrando os {{shown}} maiores de {{total}}.",
      "search_transactions":       "Buscar lançamentos…",
      "all_types":                 "Todos os tipos",
      "all_categories":            "Todas as categorias",
      "all_institutions":          "Todas as instituições",
      "date_from":                 "Data inicial",
      "date_to":                   "Data final",
      "finance_charts_section_title":       "Gráficos Financeiros",
      "finance_charts_section_text":        "Resumos visuais do desempenho financeiro da sua fazenda, incluindo tendências mensais de lucro e distribuições por categoria e instituição.",
      "finance_categories_section_title":   "Categorias Financeiras",
      "finance_categories_section_text":    "Defina as categorias usadas para classificar as transações. Adicione apelidos no WhatsApp para que sua equipe use atalhos nas mensagens — por exemplo, \"rac\" pode mapear para \"Ração e Suplementos\".",
      "finance_institutions_section_title": "Instituições Financeiras",
      "finance_institutions_section_text":  "Defina os bancos, linhas de crédito e formas de pagamento usados na sua fazenda. Adicione apelidos no WhatsApp para que sua equipe possa referenciá-los rapidamente nas mensagens.",

      // Charts section description
      "charts_section_title": "Gráficos",
      "charts_section_text":  "Visão geral visual dos dados da fazenda — composição do rebanho, resultados de reprodução, tendências climáticas e desempenho de peso — tudo em um só lugar.",
      "expand_chart":         "Expandir gráfico",
      "close":                "Fechar",

      // Billing section description
      "billing_section_title": "Assinatura e Cobrança",
      "billing_section_text":  "Gerencia a assinatura do ZapManejo. Vê o teu plano atual, escolhe um plano pelo tamanho do rebanho e atualiza os dados de pagamento.",

      "show_hints":      "Mostrar Dicas",
      "hide_hints":      "Ocultar Dicas",
      "default":         "Padrão",
      "set_as_default":  "Definir como padrão",
      "default_lot_hint": "O lote padrão recebe automaticamente as pesagens enviadas pelo WhatsApp. Os usuários podem enviar o peso sem especificar um LOT-ID e o animal será cadastrado aqui.",

      "profit_by_month":           "Lucro por Mês",
      "this_month_by_category":    "Este Mês por Categoria",
      "net_by_institution":        "Líquido por Instituição (Histórico)",
      "net_profit":                "Lucro Líquido",
      "transactions_this_month":   "Transações Este Mês",
      "select_type":               "Selecionar Tipo",
      "select_category":           "Selecionar Categoria",
      "institution":               "Instituição",
      "institutions":              "Instituições",
      "finance_institutions":      "Instituições Financeiras",
      "select_institution":        "Selecionar Instituição",
      "aliases_hint":              "Separe múltiplos apelidos com ponto e vírgula.",

      // Search
      "find_tag":     "Buscar brinco...",
      "all_breeds":   "Todas as Raças",
      "all_areas":    "Todas as Áreas",
      "all_situations":"Todas as Situações",
      "all_sexes":    "Todos os Sexos",
      "all_ages":     "Todas as Idades",
      "months":       "meses",

      // Table Titles
      "created_by":   "Criado Por",
      "tag":          "Brinco",
      "tag_prefix":   "BRINCO",
      "dam":          "Mãe",
      "dam_tag_number": "Brinco da Mãe",
      "sire_tag_number": "Brinco do Pai",
      "dam_update_failed": "Não foi possível salvar — verifique o número do brinco",
      "sire_update_failed": "Não foi possível salvar — verifique o número do brinco",
      "dam_must_be_female": "A mãe precisa ser uma fêmea",
      "sire_must_be_male": "O pai precisa ser um macho",
      "birth_form_guidance": "Digite um número de brinco para um animal identificado, ou digite o número da mãe para um bezerro recém-nascido ainda sem brinco. Você pode digitar ambos se souber.",
      "breed":        "Raça",
      "cause":        "Situação",
      "sex":          "Sexo",
      "age":          "Idade",
      "area":         "Área",
      "date":              "Data",
      "birth_date":        "Data de Nascimento",
      "registration_date": "Data de Registro",
      "who":               "Quem",
      "from":              "De",
      "dam_mother":        "Mãe (vaca)",
      "sire_father":       "Pai (touro)",
      "registered_by":     "Registrado por",
      "registered_from":   "Registrado de",
      "amount":       "Valor",
      "temperature":  "Temperatura",
      "nickname":     "Apelido",
      "nicknames":    "Apelidos no WhatsApp",
      "nicknames_hint":        "Separe múltiplos apelidos com ponto e vírgula.",
      "nicknames_placeholder": "Apelidos no WhatsApp, separados por ponto e vírgula (ex: doente;doença)",
      "name":         "Nome",
      "protocol_name":"Protocolo",
      "start_date":   "Data de início",
      "end_date":     "Data final",
      "current_day":  "Dia atual",
      "predicted_iatf":"IATF previsto",
      "protocol_progress":    "Progresso do Protocolo",
      "lot_protocol_section_title": "Acompanhamento de Protocolo do Lote",
      "lot_protocol_section_text":  "Atribuir um plano abaixo inicia um novo ciclo de acompanhamento para este lote. Iniciar um novo plano sempre encerra o ciclo atualmente ativo.",
      "confirm_new_cycle_title":   "Iniciar um novo ciclo?",
      "confirm_new_cycle_active_warning": "Isso encerrará o ciclo em andamento (iniciado em {{date}}) e iniciará um novo.",
      "confirm_new_cycle_yes":     "Sim, Iniciar Ciclo",
      "no_active_protocol":   "Nenhum protocolo atribuído a este lote.",
      "start_tracking":       "Iniciar Acompanhamento",
      "mark_step_complete":   "Marcar Concluído",
      "step_current":         "Atual",
      "step_upcoming":        "Próximo",
      "completed_on":         "Concluído em",
      "completed_by_label":   "por",
      "protocol_history":     "Execuções Anteriores",
      "ended_on":             "Encerrado",
      "steps_completed":      "etapas concluídas",
      "lot_prefix":    "REPRO",
      "weight_lot_prefix": "PESO",
      "days_completed": "Dias concluídos",
      "notes":        "Notas",
      "language":     "Idioma",
      "message_type": "Tipo",
      "raw_message":  "Mensagem",
      "direction":    "Direção",
      "source":       "Origem",

      // Buttons
      "add_button":             "Adicionar",
      "next_button":            "Próximo",
      "back_button":            "Voltar",
      "delete_error":           "Falha ao excluir",
      "animal_added_success":   "Animal adicionado com sucesso.",
      "bull_added_success":     "Touro adicionado com sucesso.",
      "reproduction_duplicate_msg": "Este animal já está neste lote.",

      // Reproduction
      "hide-protocol-view": "Ocultar visualização do protocolo",
      "show-protocol-view": "Mostrar visualização do protocolo",
      "hide-notes-view":    "Ocultar visualização de notas",
      "show-notes-view":    "Visualizar notas do programa",
      "protocol_view":      "Protocolo",
      "notes_view":         "Notas",
      "pregnancy-success-rate-by-lot":"Taxa de Sucesso de Prenhez por Lote",
      "birth-rate-percentage":"Porcentagem da taxa de natalidade",
      "bull_success_rate_chart":   "Taxa de Sucesso de Prenhez por Touro / Raça",
      "group_by_bull":             "Por Touro",
      "group_by_breed":            "Por Raça",
      "chart_summary_best_bull":   "{{name}} atingiu a maior taxa de prenhez com {{percent}}%.",
      "chart_summary_no_bull_data":"Nenhum dado de touro registrado ainda.",
      "success_rate_pct":          "Taxa de Sucesso (%)",
      "chart_tooltip_success_fraction": "{{success}} de {{total}} tiveram sucesso",
      "protocol_success_rate_chart":   "Taxa de Sucesso de Prenhez por Protocolo",
      "chart_summary_best_protocol":   "{{name}} atingiu a maior taxa de sucesso com {{percent}}%.",
      "chart_summary_no_protocol_data":"Nenhum dado de protocolo registrado ainda.",
      "reproduction_results_chart_title": "Resultados da Reprodução",
      "for_month":                 "de {{month}}",
      "chart_outcome_label_pregnant":         "estão prenhas",
      "chart_outcome_label_returned_to_estrus": "retornaram ao cio neste ciclo",
      "chart_outcome_label_aborted":          "perderam a prenhez",
      "chart_outcome_label_calved_alive":     "pariram com sucesso",
      "chart_outcome_label_calved_stillborn": "tiveram natimorto",
      "chart_dam_died_note_singular": "1 matriz prenha morreu este mês e não está incluída no resultado deste gráfico.",
      "chart_dam_died_note_plural":   "{{count}} matrizes prenhas morreram este mês e não estão incluídas no resultado deste gráfico.",

      "proceedure": "Procedimento",

      // Breeds
      "angus":         "Angus",
      "brangus":       "Brangus",
      "cruzada":       "Cruzada",
      "nelore":        "Nelore",
      "sta_zelia":     "Sta. Zelia",
      "murrah":        "Murrah",
      "mediterrâneo":  "Mediterrâneo",
      "jafarabadi":    "Jafarabadi",
      "carabao":       "Carabao",
      "marchigiana":   "Marchigiana",
      "charolais":     "Charolais",
      "sindi":         "Sindi",
      "breed_type":        "Tipo",
      "breed_type_custom": "Do Usuário",
      "breed_type_system": "Do Sistema",

      // Death Causes
      "aborto":       "Aborto",
      "morreu":       "Morreu",
      "morto":        "Morto",
      "nasceu-morto": "Nasceu Morto",
      "natimorto":    "Natimorto",
      "natimortos":   "Natimortos",
      "viva":         "Viva",

      // Upload Steps
      "upload_select_file":    "Selecionar Arquivo CSV",
      "upload_map_columns":    "Mapear Colunas",
      "upload_map_columns_hint": "Associe cada campo de dados a uma coluna do seu CSV.",
      "upload_map_values":     "Mapear Valores",
      "upload_map_values_hint": "Para campos de lista, mapeie os valores do CSV para os valores esperados.",
      "upload_no_enum_fields": "Nenhum campo para mapear. Todos os valores estão corretos.",
      "upload_review_submit":  "Revisar e Enviar",
      "upload_records_count":  "{{count}} registros serão enviados para",
      "upload_column_mapping": "Mapeamento de Colunas",
      "upload_preview":        "Pré-visualização (primeiras 3 linhas)",
      "upload_step_file":      "Arquivo",
      "upload_step_columns":   "Colunas",
      "upload_step_values":    "Valores",
      "upload_step_submit":    "Enviar",
      "upload_skip":           "— pular —",
      "upload_select":         "— selecionar —",
      "upload_uploading":      "Enviando...",
      "upload_upload":         "Enviar",
      "upload_back":           "Voltar",
      "upload_next":           "Próximo",
      "upload_field":          "Campo",
      "upload_csv_column":     "Coluna CSV",
      "upload_csv_value":      "Valor CSV",
      "upload_maps_to":        "Mapeia Para",
      "upload_skipped":        "pulado",
      "upload_default":        "padrão",
      "upload_failed":         "Falha no envio",
      "upload_parse_error":    "Não foi possível analisar os cabeçalhos do CSV.",
      "upload_desc_tag":       "Brinco do animal",
      "upload_desc_dam":       "Brinco da mãe",
      "upload_desc_breed":     "Raça do animal",
      "upload_desc_sex":       "Sexo do animal",
      "upload_desc_area":      "Nome da área/pasto",
      "upload_desc_cause":     "Situação do animal",
      "upload_desc_date":      "Data de nascimento (DD/MM/AAAA)",
      "upload_desc_is_alive":    "Se o animal está vivo (true/false). Padrão: true se não mapeado.",
      "upload_desc_is_pregnant": "Se o animal está prenha (true/false). Padrão: false se não mapeado.",
      "is_alive":              "Está Vivo",
      "is_pregnant":           "Está Prenha",
      "upload_desc_weight_tag":  "Numero do brinco do animal",
      "upload_desc_weight_kg":   "Peso em quilogramas",
      "upload_desc_weight_date": "Data da pesagem (DD/MM/AAAA ou AAAA-MM-DD)",

      // Notes
      "no_notes":             "Nenhuma nota ainda",
      "add_note":             "Adicionar Nota",
      "add_note_placeholder": "Escreva uma nota...",

      // Photos
      "photos":    "Fotos",
      "no_photos": "Nenhuma foto ainda",

      // Calves
      "calves":               "Bezerros",
      "no_calves":            "Nenhum bezerro registrado",
      "loading":              "Carregando",
      "male":                 "Macho",
      "female":               "Fêmea",
      "sex_not_set":          "Não Definido",
      "animals_sex_not_set":  "Sexo Não Definido",
      "needs_attention":      "Requer Atenção",

      // Profile
      "profile":      "Perfil",
      "logout":       "Sair",
      "change_pref_lang": "Altere seu idioma preferido",
      "change_password":  "Altere Senha",

      // Lots
      "lots":                    "Lotes",
      "lots_title":              "Lotes de Reprodução",
      "lot":                     "Lote",
      "lot_id":                  "ID do Lote",
      "all_lots":                "Todos os Lotes",
      "select_lot":              "Selecionar Lote",
      "animals_count":           "Animais",
      "animals_count_short":     "animais",
      "animal_count_singular":   "animal",
      "lot_count":               "Contagem",
      "view_animals":            "Ver Animais",
      "view_lot":                "Ver Lote",
      "add_lot":                 "Adicionar Lote",
      "error_creating_lot":          "Erro ao criar lote",
      "select_protocol":             "Selecionar Protocolo",
      "select_protocol_error":       "Por favor, selecione um protocolo",
      "repro_lot_name":              "Nome do Lote",
      "repro_lot_name_placeholder":  "ex: IATF Primavera 2026",
      "assign_protocol":         "Atribuir Protocolo",
      "not_assigned":            "Não atribuído",
      "change_protocol":         "Alterar Protocolo",
      "no_animals_in_lot":       "Nenhum animal neste lote",
      "days_status":             "Status dos Dias",

      // Bulls
      "bulls":                   "Touros",
      "bull":                    "Touro",
      "bull_name":               "Nome do Touro",
      "bull_breed":              "Raça",
      "bull_tag":                "Número do Brinco (opcional)",
      "bull_tag_hint":           "Se este touro é um animal conhecido no seu rebanho, informe o número do brinco — a raça será preenchida automaticamente e os bezerros poderão mostrá-lo como Pai.",
      "bull_tag_hint_list":      "Nenhum número de brinco cadastrado para este touro ainda. Adicione um na coluna Brinco acima para começar a ver os bezerros que ele gerou.",
      "select_bull":             "Selecionar Touro",
      "sire":                    "Pai",
      "sired_calves":            "Bezerros Gerados",
      "no_sired_calves":         "Nenhum bezerro registrado",
      "aliases":                 "Apelidos no WhatsApp",
      "alias":                   "Apelido no WhatsApp",
      "add_alias":               "Adicionar Apelido",
      "remove":                  "Remover",
      "add_bull":                "Adicionar Touro",

      // Settings
      "default_protocol":          "Protocolo Padrão",
      "default_protocol_settings":        "Protocolo Padrão de Reprodução",
      "default_protocol_hint":            "Atribuído automaticamente ao criar um lote de reprodução pelo WhatsApp.",
      "default_herd_protocol_settings":   "Plano Geral Padrão",
      "default_herd_protocol_hint":       "Atribuído opcionalmente ao criar um lote de rebanho pelo WhatsApp.",
      "default_weight_protocol_settings": "Plano Padrão de Peso",
      "default_weight_protocol_hint":     "Atribuído opcionalmente ao criar um lote de peso pelo WhatsApp.",
      "default_bull":              "Touro Padrão",
      "default_bull_settings":     "Touro Padrão para WhatsApp",
      "default_bull_hint":       "Defina o touro padrão usado ao criar lotes via mensagens do WhatsApp.",
      "settings_saved":          "Configurações salvas com sucesso",
      "settings_save_error":     "Erro ao salvar configurações",

      // Password Reset
      "current_password":        "Senha Atual",
      "password_changed_success": "Senha alterada com sucesso",
      "enter_verification_code": "Digite o código de verificação",
      "email_sent_to":           "Enviamos um e-mail para:",
      "enter_code_placeholder":  "Digite o Código",
      "forgot_password_instructions": "Digite seu endereço de e-mail e enviaremos um código para redefinir sua senha.",
      "send_reset_code":         "Enviar Código",
      "reset_code_sent":         "Um código foi enviado para o seu e-mail.",
      "enter_reset_code":        "Digite o Código",
      "enter_code_instructions": "Digite o código de 6 dígitos enviado para seu e-mail.",
      "verification_code":       "Código de Verificação",
      "verify_code":             "Verificar Código",
      "verifying":               "Verificando...",
      "resend_code":             "Reenviar Código",
      "reset_password":          "Redefinir Senha",
      "new_password":            "Nova Senha",
      "confirm_new_password":    "Confirmar Nova Senha",
      "passwords_do_not_match":  "As senhas não coincidem",
      "phone_number_required":   "Número de telefone é obrigatório",
      "password_too_short":      "A senha deve ter pelo menos 6 caracteres",
      "password_reset_success":  "Senha redefinida com sucesso! Redirecionando para o login...",
      "back_to_login":           "Voltar ao Login",
      "back":                    "Voltar",
      "mark_done":               "Marcar feito",
      "undo":                    "Desfazer",
      "clear_filter":            "Limpar filtro",
      "automatic":               "Automático",

      // WhatsApp Message Samples — Page Header
      "samples_page_title": "Exemplos de Mensagens WhatsApp",

      // WhatsApp Message Samples — Herd (Births & Deaths)
      "samples_births_description":       "Registre nascimentos de animais com brinco, sexo e raça. Opcionalmente inclua o nome da área na última linha.",
      "samples_deaths_description":       "Registre mortes de animais pelo brinco e causa. Atualiza os registros de nascimento existentes.",
      "samples_sep_simple_births":        "Exemplo 1: Nascimentos simples",
      "samples_sep_births_with_area":     "Exemplo 2: Com área",
      "samples_sep_calf_with_dam":        "Exemplo 3: Bezerro com mãe",
      "samples_sep_death_causes":         "Causas de morte",
      "samples_deaths_user_input":        "2235 doente\n2236 acidente\n2237 abatido",
      "samples_births_response_1":        "Zap Manejo identificou dados de nascimento. Adicionamos 3 nascimentos à área desconhecida.",
      "samples_births_response_2":        "Zap Manejo identificou dados de nascimento. Adicionamos 2 nascimentos à área Fazenda Norte.",
      "samples_births_response_3":        "Zap Manejo identificou dados de nascimento. Adicionamos 2 nascimentos à área desconhecida.",
      "samples_deaths_response":          "Zap Manejo identificou dados de morte. Adicionamos 3 mortes.",
      "samples_birth_format_title":       "Referência de Formato de Nascimento:",
      "samples_birth_format_regular":      "Nascimento comum (ex.: 12345 m nelore)",
      "samples_birth_format_code_regular": "brinco sexo raça",
      "samples_birth_format_calf_en":      "Entrada de bezerro em inglês",
      "samples_birth_format_code_calf_en": "calf mãe sexo raça",
      "samples_birth_format_calf_pt":      "Entrada de bezerro em português",
      "samples_birth_format_code_calf_pt": "bezerro mãe sexo raça",
      "samples_birth_format_calf_f":       "Bezerra fêmea em português",
      "samples_birth_format_code_calf_f":  "bezerra mãe sexo raça",
      "samples_sex_values_label":         "Valores de Sexo:",
      "samples_sex_values":               "m (macho), f (fêmea)",
      "samples_breeds_label":             "Raças:",
      "samples_breeds_list":              "angus, nelore, brangus, cruzada, murrah, sta.zelia, e mais",
      "samples_death_causes_label":       "Causas de Morte:",
      "samples_death_causes_list":        "abatido (slaughtered), doença/doente (sickness), acidente (accident), velhice (old age), outro (other) — ou qualquer causa personalizada em Configurações",

      // WhatsApp Message Samples — Climate
      "samples_rain_description":         "Registre dados de chuva com data e quantidade em milímetros. Opcionalmente, informe uma área na última linha, ou uma área cadastrada no fim da linha.",
      "samples_temp_description":         "Registre dados de temperatura com data e valor em Celsius. Opcionalmente, informe uma área na última linha, ou uma área cadastrada no fim da linha.",
      "samples_weather_title":            "Consulta de Clima",
      "samples_weather_description":      "Obtenha o clima atual de qualquer localização.",
      "samples_weather_keywords":         "clima, tempo, weather",
      "samples_sep_rainfall":             "Registros de chuva",
      "samples_sep_temperature":          "Registros de temperatura",
      "samples_sep_weather":              "Consulta de clima",
      "samples_rain_response":            "Zap Manejo identificou dados de precipitação. Adicionamos 77 mm de chuva.",
      "samples_temp_response":            "Zap Manejo identificou dados de temperatura. Adicionamos dados de temperatura dos últimos 3 dias.",
      "samples_sep_climate_with_area":    "Com área",
      "samples_rain_area_response":       "Zap Manejo identificou dados de precipitação. Adicionamos 55 mm de chuva na área Fazenda Norte.",
      "samples_temp_area_response":       "Zap Manejo identificou dados de temperatura. Adicionamos 1 temperatura na área Fazenda Norte.",
      "samples_climate_format_title":     "Referência de Formato:",
      "samples_climate_format_rain":          "Chuva (ex.: 15/03 25mm)",
      "samples_climate_format_code_rain":     "dd/mm quantidade mm [área]",
      "samples_climate_format_temp":          "Temperatura (ex.: 15/03 32C)",
      "samples_climate_format_code_temp":     "dd/mm temp C [área]",
      "samples_climate_format_weather":       "Consulta de clima",
      "samples_climate_format_code_weather":  "clima para localização",

      // WhatsApp Message Samples — Weight
      "samples_weight_description":       "Registre o peso dos animais com brinco e peso em quilogramas.",
      "samples_sep_basic_weight":         "Registro básico de peso",
      "samples_sep_weight_space":         "Com espaço antes de kg",
      "samples_sep_weight_date":          "Com data opcional",
      "samples_sep_weight_multiple":      "Múltiplos registros",
      "samples_weight_response_1":        "Zap Manejo registrou dados de peso. Adicionamos 1 registro totalizando 500 kg.",
      "samples_weight_response_2":        "Zap Manejo registrou dados de peso. Adicionamos 3 registros totalizando 1550 kg.",
      "samples_weight_format_title":      "Referência de Formato:",
      "samples_weight_format_basic":           "Formato básico (ex.: 1234, 500kg)",
      "samples_weight_format_code_basic":      "brinco, peso kg",
      "samples_weight_format_date":            "Com data opcional (ex.: 1234, 500kg 15/03)",
      "samples_weight_format_code_date":       "brinco, peso kg dd/mm",
      "samples_weight_format_no_comma":        "Sem vírgula (ex.: 1234 500kg)",
      "samples_weight_format_code_no_comma":   "brinco peso kg",
      "samples_weight_keyword_note":           "O sufixo kg identifica mensagens de peso.",
      "samples_weight_lot_title":              "Peso com Atribuição de Lote",
      "samples_weight_lot_description":        "Registre um peso e associe o animal a um lote de peso específico em uma mensagem.",
      "samples_sep_weight_lot_enroll":         "Cadastrar animal + registrar peso",
      "samples_sep_weight_lot_existing":       "Já cadastrado — apenas atualizar peso",
      "samples_sep_weight_lot_date":           "Com data opcional",
      "samples_weight_lot_response_enroll":    "Brinco 1234 adicionado ao PESO-0001. Peso 500 kg registrado.",
      "samples_weight_lot_response_existing":  "Peso 520 kg registrado para brinco 1234 no PESO-0001.",
      "samples_weight_format_lot":             "Atribuir ao lote e registrar peso (ex: PESO-0001 1234 500kg)",
      "samples_weight_format_code_lot":        "PESO-XXXX brinco peso kg",
      "samples_weight_format_lot_date":        "Com data opcional (ex: PESO-0001 1234 500kg 15/03)",
      "samples_weight_format_code_lot_date":   "PESO-XXXX brinco peso kg dd/mm",
      "samples_keyword_label":            "Palavra-chave:",
      "keywords_label":                   "Palavras-chave:",

      // WhatsApp Message Samples — Reproduction
      "samples_create_lot_title":         "Criar Novo Lote",
      "samples_create_lot_description":   "Inicie um novo lote de IATF usando seu protocolo padrão. Opcionalmente especifique um touro.",
      "samples_add_animals_title":        "Adicionar Animais ao Lote",
      "samples_add_animals_description":  "Adicione brincos de animais a um lote existente. Opcionalmente especifique um touro por animal.",
      "samples_lot_status_title":         "Consultar Status do Lote",
      "samples_lot_status_description":   "Consulte o status atual e as tarefas de um lote.",
      "samples_sep_lot_default_bull":     "Criar lote (touro padrão)",
      "samples_sep_lot_specific_bull":    "Criar lote com touro específico",
      "samples_sep_lot_bull_next_line":   "Touro na próxima linha",
      "samples_sep_add_default_bull":     "Adicionar animais (usar touro do lote)",
      "samples_sep_add_specific_bull":    "Com touros específicos por animal",
      "samples_sep_status_query":         "Consulta de status",
      "samples_add_animals_response_1":   "3 animais adicionados ao lote IATF-0042.",
      "samples_add_animals_response_2":   "3 animais adicionados ao lote IATF-0042.",
      "samples_repro_format_creating_title":  "Criando Lotes:",
      "samples_repro_format_new_lot":         "Usa o protocolo padrão e o touro padrão",
      "samples_repro_format_new_lot_bull":    "Usa o protocolo padrão com o touro \"jabriel\"",
      "samples_repro_format_novo_lote":       "novo lote + nova linha + touro — Touro na próxima linha",
      "samples_repro_format_adding_title":    "Adicionando Animais:",
      "samples_repro_format_animal_default":  "12345 — Usa o touro padrão do lote",
      "samples_repro_format_animal_bull":     "12345 angus — Usa o touro \"angus\" para este animal",
      "samples_repro_format_iatf_title":      "Formatos de Referência IATF:",
      "samples_repro_format_iatf_examples":   "IATF-0001, IATF 0001, IATF0001, iatf-42",
      // Finance Samples
      "samples_finance_gain_title":           "Registrando Receita",
      "samples_finance_gain_description":     "Use 'ganho' ou 'receita' seguido de valor, categoria, observação opcional e data opcional.",
      "samples_finance_keywords_gain":        "ganho, receita",
      "samples_sep_finance_simple_gain":      "Entrada simples de ganho",
      "samples_finance_msg_gain_simple":      "ganho 1500 venda animal",
      "samples_finance_gain_response_1":      "✅ 1 lançamento financeiro registrado\n+ R$ 1.500,00 — Venda Animal",
      "samples_sep_finance_gain_institution": "Ganho com instituição",
      "samples_finance_msg_gain_institution": "ganho 1500 venda animal crédito rural",
      "samples_finance_gain_response_4":      "✅ 1 lançamento financeiro registrado\n+ R$ 1.500,00 — Venda Animal · Crédito Rural",
      "samples_sep_finance_gain_notes":       "Ganho com instituição e observação",
      "samples_finance_msg_gain_notes":       "ganho 800 mão de obra dinheiro conserto de cerca",
      "samples_finance_gain_response_2":      "✅ 1 lançamento financeiro registrado\n+ R$ 800,00 — Mão de Obra · Dinheiro\n  conserto de cerca",
      "samples_sep_finance_gain_date":        "Ganho com instituição e data",
      "samples_finance_msg_gain_date":        "ganho 2500 venda animal banco 15/03",
      "samples_finance_gain_response_3":      "✅ 1 lançamento financeiro registrado\n+ R$ 2.500,00 — Venda Animal · Banco · 15/03",
      "samples_finance_loss_title":           "Registrando Despesas",
      "samples_finance_loss_description":     "Use 'perda', 'despesa' ou 'gasto' seguido de valor, categoria, observação opcional e data opcional.",
      "samples_finance_keywords_loss":        "perda, despesa, gasto",
      "samples_sep_finance_simple_loss":      "Entrada simples de perda",
      "samples_finance_msg_loss_simple":      "perda 200 ração",
      "samples_finance_loss_response_1":      "✅ 1 lançamento financeiro registrado\n- R$ 200,00 — Ração",
      "samples_sep_finance_loss_institution": "Perda com instituição",
      "samples_finance_msg_loss_institution": "perda 200 ração dinheiro",
      "samples_finance_loss_response_4":      "✅ 1 lançamento financeiro registrado\n- R$ 200,00 — Ração · Dinheiro",
      "samples_sep_finance_loss_notes":       "Perda com instituição e observação",
      "samples_finance_msg_loss_notes":       "perda 350 veterinário cartão vacinação",
      "samples_finance_loss_response_2":      "✅ 1 lançamento financeiro registrado\n- R$ 350,00 — Veterinário · Cartão de Crédito\n  vacinação",
      "samples_sep_finance_loss_date":        "Perda com instituição e data",
      "samples_finance_msg_loss_date":        "perda 150 combustível dinheiro 20/03",
      "samples_finance_loss_response_3":      "✅ 1 lançamento financeiro registrado\n- R$ 150,00 — Combustível · Dinheiro · 20/03",
      "samples_finance_project_title": "Acompanhando um Projeto",
      "samples_finance_project_description": "Cite um projeto em qualquer parte de uma mensagem financeira, pelo apelido ou código, e o lançamento conta para ele. Toda resposta mostra o saldo atualizado do projeto.",
      "samples_sep_finance_project_expense": "Despesa de um projeto",
      "samples_finance_msg_project_expense": "gasto 1200 equipamento curral",
      "samples_finance_project_response_expense": "✅ 1 lançamento financeiro registrado\n- R$ 1.200,00 — Equipamento · PROJ-0001\n\n📁 *PROJ-0001 — Reforma do curral*\nTambém conhecido como: curral\nSaldo: −R$ 2.000,00 🔴",
      "samples_sep_finance_project_flip": "Receita que deixa o saldo positivo",
      "samples_finance_msg_project_flip": "receita 3000 outros curral venda de sucata",
      "samples_finance_project_response_flip": "✅ 1 lançamento financeiro registrado\n+ R$ 3.000,00 — Outro · PROJ-0001\n  venda de sucata\n\n📁 *PROJ-0001 — Reforma do curral*\nTambém conhecido como: curral\nSaldo: R$ 1.000,00 🟢\n🎉 Voltou ao positivo",
      "samples_finance_format_title":              "Formato da Mensagem:",
      "samples_finance_format_gain":               "registrar ganho (receita)",
      "samples_finance_format_code_gain":          "ganho valor categoria",
      "samples_finance_format_loss":               "registrar perda (despesa)",
      "samples_finance_format_code_loss":          "perda valor categoria",
      "samples_finance_format_institution":        "instituição opcional (banco, dinheiro, etc.)",
      "samples_finance_format_code_institution":   "ganho valor categoria instituição",
      "samples_finance_format_notes":              "tudo após a instituição é tratado como observação",
      "samples_finance_format_code_notes":         "ganho valor categoria instituição notas",
      "samples_finance_format_date":               "data opcional, padrão é hoje",
      "samples_finance_format_code_date":          "ganho valor categoria instituição dd/mm",
      "samples_finance_categories_label":          "Categorias:",
      "samples_finance_categories_list":           "venda animal, compra animal, mão de obra, ração, veterinário, equipamento, combustível, outros",
      "samples_finance_institutions_label":   "Instituições:",
      "samples_finance_institutions_list":    "dinheiro, banco, crédito rural, cartão, cheque, outros",
      // Lists samples
      "samples_lists_description":            "Crie listas, adicione itens e consulte uma lista pelo WhatsApp. LISTA ou LIST funcionam.",
      "samples_sep_lists_create":             "Criar uma lista",
      "samples_lists_create_user_input":      "nova lista Loja",
      "samples_lists_create_response":        "✅ *LISTA-0003 — Loja criada*\n\nPara adicionar itens:\nLISTA-0003\nitem1\nitem2",
      "samples_sep_lists_add_default":        "Adicionar à lista padrão",
      "samples_sep_lists_add_specific":       "Adicionar a uma lista específica",
      "samples_sep_lists_query":              "Consultar status da lista",
      "samples_lists_add_response":           "✓ leite adicionado à LISTA-0001 Compras Semanais.",
      "samples_lists_alias_title":            "Pelo nome ou apelido",
      "samples_lists_alias_description":      "O nome da lista ou qualquer apelido no WhatsApp (definido na página da lista) funciona no lugar do código, com ou sem LISTA na frente.",
      "samples_sep_lists_alias_add":          "Adicionar pelo apelido",
      "samples_lists_alias_add_input":        "loja pregos",
      "samples_lists_alias_add_response":     "✓ pregos adicionado à LISTA-0002 Materiais.",
      "samples_sep_lists_alias_keyword":      "Com LISTA na frente",
      "samples_lists_alias_keyword_input":    "LISTA loja parafusos, cola",
      "samples_lists_alias_keyword_response": "✓ 2 itens adicionados à LISTA-0002 Materiais.",
      "samples_sep_lists_alias_query":        "Consultar pelo nome",
      "samples_lists_alias_query_input":      "Materiais",
      "samples_lists_alias_query_response":   "LISTA-0002\nMateriais\nApelidos: loja\nCriado por: Mark\n\nAtiva\n❌ Pregos\n❌ Parafusos\n❌ Cola",
      "samples_sep_lists_alias_status":       "Marcar pelo apelido",
      "samples_lists_alias_status_input":     "comprei loja pregos R$20",
      "samples_lists_alias_status_response":  "✅ pregos marcado como comprado (LISTA-0002 Materiais) · R$ 20,00",
      "samples_lists_format_alias":           "o nome ou apelido da lista funciona onde LISTA-0001 funciona",
      "samples_lists_item":                   "leite",
      "samples_lists_query_response":         "LISTA-0001\nCompras Semanais\nApelidos: compras\nCriado por: Mark\n\nAtiva\n❌ Leite\n❌ Ovos\n✅ Pão",
      "samples_lists_format_title":           "Referência de Formato",
      "samples_lists_format_add":             "adicionar item à lista padrão",
      "samples_lists_format_specific":        "adicionar item a uma lista específica",
      "samples_lists_format_query":           "consultar status e itens da lista",
      "samples_lists_format_create":          "criar uma lista (nome opcional)",
      "samples_lists_format_status":          "marcar um item como comprado / concluído / pendente, pelo nome; custo opcional (R$150); LISTA sem número = lista padrão",
      "samples_lists_status_title":           "Marcar itens",
      "samples_lists_status_description":     "Mude o status de um item pelo nome dele na lista. Um nome exato tem prioridade; senão, cada palavra digitada precisa ser o começo de uma palavra do item. Com custo, numa lista vinculada a um projeto, a despesa é registrada.",
      "samples_sep_lists_status_match":       "Um item encontrado (com custo)",
      "samples_lists_status_match_input":     "comprei LISTA-0003 arame farpado R$150",
      "samples_lists_status_match_response":  "✅ arame farpado marcado como comprado (LISTA-0003 Loja) · R$ 150,00\nDespesa registrada no projeto da lista.",
      "samples_sep_lists_status_ambiguous":   "Mais de um item",
      "samples_lists_status_ambiguous_input": "LISTA-0003 comprei arame",
      "samples_lists_status_ambiguous_response": "Mais de um item corresponde em LISTA-0003 Loja: arame farpado, alicate de arame. Seja mais específico.",
      "samples_sep_lists_status_nomatch":     "Nenhum item",
      "samples_lists_status_nomatch_input":   "comprei LISTA-0003 botas",
      "samples_lists_status_nomatch_response": "Nenhum item correspondente em LISTA-0003 Loja.\nItens que podem ser marcados como comprado: sal, sal mineral, alicate de arame, pregos 2 pol",
      "samples_sep_lists_status_undo":        "Desfazer",
      "samples_lists_status_undo_input":      "pendente LISTA-0003 arame farpado",
      "samples_lists_status_undo_response":   "✅ arame farpado marcado como pendente (LISTA-0003 Loja) · R$ 150,00",

      // Tier 2 feature summary samples
      "samples_finance_summary_description":       "Receba um resumo de receitas e despesas dos últimos 30 dias.",
      "samples_finance_summary_response":          "*Finanças — Últimos 30 Dias*\n\n*Receitas:* +8500 (6)\n*Despesas:* -3200 (4)\n*Saldo:* +5300",
      "samples_weight_summary_description":        "Receba um resumo de todos os lotes de peso ativos.",
      "samples_weight_summary_response":           "*Lotes de Peso — 2 ativos*\n\nPESO-0001 — Lote Primavera: 48 animais _(padrão)_\nPESO-0002 — Novos Animais: 12 animais",
      "samples_repro_summary_description":         "Receba um resumo de todos os lotes IATF e contagem de animais.",
      "samples_repro_summary_response":            "*Reprodução — 2 lote(s)*\n\nREPRO-0001: 24 animais\n  Nascimentos: 18\n  Abortos: 2\n  Falhas de concepção: 3\n  Mortes de matriz: 1\n  Taxa de sucesso: 78%\n\nREPRO-0002: 18 animais\n  Nascimentos: 15\n  Abortos: 1\n  Falhas de concepção: 2\n  Mortes de matriz: 0\n  Taxa de sucesso: 83%",
      "samples_lists_summary_description":         "Receba um resumo de todas as listas ativas.",
      "samples_lists_summary_response":            "*Listas — 3 ativa(s)*\n\nLISTA-0001 — Compras Semanais (compras): 5 itens\nLISTA-0002 — Materiais (loja): 2 itens\nLISTA-0003 — Mantimentos: 8 itens\n\n📝 Comandos:\n\nPara adicionar à lista padrão:\nLISTA {item}\n\nPara adicionar a uma lista específica:\nLISTA-0001 {item}\n\nPara ver uma lista específica:\nLISTA-0001\n\nPara marcar um item como comprado:\ncomprei LISTA-0001 {item}\n\nO nome ou apelido da lista também funciona no lugar de LISTA-0001.",
      "samples_finance_summary_user_input":        "finanças",
      "samples_weight_summary_user_input":         "peso",
      "samples_repro_summary_user_input":          "reprodução",
      "samples_lists_summary_user_input":          "listas",

      // Overview samples
      "samples_overview_tab":                 "Visão Geral",
      "samples_overview_description":         "Receba um resumo completo do rancho — rebanho, equipe, lotes ativos, chuva e finanças do mês.",
      "samples_overview_response":            "*Zap Manejo — Visão Geral*\n\n*Rebanho:* 342 animais\n*Equipe:* 5 membros\n*Mensagens:* 1204\n\n*Lotes IATF:* 3\n*Lotes de Peso Ativos:* 2\n\n*Chuva em Maio:* 47mm\n*Finanças em Maio:* +5200 / -1800",
      "samples_overview_user_input":          "visão geral",

      // Ranch samples
      "samples_ranch_tab":                        "Fazendas",
      "samples_ranch_list_title":                 "Lista de Fazendas",
      "samples_ranch_list_description":           "Veja sua fazenda ativa atual e todas as fazendas disponíveis com seus comandos de troca.",
      "samples_ranch_list_response":              "🏡 Resumo das Fazendas\n\nFazenda atual: Fazenda Terpstra\n\nSuas fazendas:\n• Fazenda Terpstra — mudar: fazenda terp\n• Fazenda Sul — mudar: fazenda sul\n\nEnvie \"fazenda [apelido]\" para mudar sua fazenda ativa.",
      "samples_ranch_switch_title":               "Mudar de Fazenda",
      "samples_ranch_switch_description":         "Mude sua fazenda ativa enviando seu apelido.",
      "samples_sep_ranch_switch":                 "Mudando para outra fazenda",
      "samples_ranch_switch_response":            "✅ Sua fazenda ativa agora é: Fazenda Sul",
      "samples_sep_ranch_already_active":         "Já está nessa fazenda",
      "samples_ranch_already_active_response":    "ℹ️ Fazenda Terpstra já é sua fazenda ativa.",
      "samples_ranch_format_title":               "Formato",
      "samples_ranch_format_list":                "Mostrar sua fazenda atual e todas as fazendas disponíveis",
      "samples_ranch_format_switch":              "Mudar para a fazenda com este apelido",
      "samples_ranch_user_input":                 "fazenda",
      "samples_ranch_switch_user_input":          "fazenda terp",

      // Help samples
      "samples_help_tab":                     "Ajuda",
      "samples_help_general_description":     "Receba uma referência rápida de todos os comandos WhatsApp suportados.",
      "samples_help_feature_description":     "Receba a referência de formato detalhada para uma funcionalidade específica.",
      "samples_help_general_response":        "*Zap Manejo — Comandos*\n\n🐄 *Rebanho*\n  12345 m nelore — nascimento\n  12345 doente — morte\n  rebanho — resumo\n\n📋 *Listas*\n  LISTA item — adicionar à lista padrão\n  LISTA-0001 item — adicionar a uma lista\n  LISTA-0001 — consultar lista\n  comprei LISTA-0001 item — marcar como comprado\n\n⚖️ *Peso*\n  1234, 500kg — registrar peso\n  PESO-0001 1234 500kg — atribuir a lote\n\n🌧️ *Clima*\n  15/03 25mm — chuva\n  15/03 32C — temperatura\n  clima para local — previsão\n\n💰 *Finanças*\n  ganho 500 categoria — receita\n  perda 200 categoria — despesa\n\n🔬 *Reprodução*\n  novo lote — criar lote IATF\n  IATF-0001 — status do lote\n\n_Digite_ *ajuda <área>* _para mais detalhes_\n_Ex:_ peso, rebanho, listas, finanças, clima, reprodução",
      "samples_help_weight_response":         "*Peso — Referência de Formato*\n\nRegistrar peso:\n  1234, 500kg\n  1234, 500kg 15/03\n  1234 500kg\n\nLotes de peso:\n  PESO-0001 1234 500kg\n  PESO-0001 1234 500kg 15/03\n  PESO-0001 — resumo do lote\n  PESO-0001 -3 — pontuação\n\nPalavra-chave: kg",
      "samples_help_user_input":              "ajuda",
      "samples_help_weight_user_input":       "ajuda peso",

      // Billing
      "billing":                    "Cobrança",
      "next_billing":               "Próxima cobrança",
      "billing_success_msg":        "A tua assinatura está ativa. Bem-vindo!",
      "billing_cancel_msg":         "Assinatura não concluída. Podes assinar a qualquer momento na página de Cobrança.",
      "manage_billing":             "Gerenciar assinatura",

      // Billing — herd-size bands (2026-10)
      "billing_free_title":            "Plano gratuito",
      "billing_free_desc":             "Até {{max}} animais. Bezerros com menos de 8 meses não contam.",
      "billing_free_current":          "Tu estás no plano gratuito.",
      "billing_choose_band":           "Escolhe o plano pelo tamanho do teu rebanho",
      "billing_interval_month":        "Mensal",
      "billing_interval_year":         "Anual",
      "billing_annual_note":           "Paga 10 meses, leva 12 — 2 meses grátis",
      "billing_price_month":           "{{price}}/mês",
      "billing_price_year":            "{{price}}/ano",
      "billing_price_unavailable":     "—",
      "billing_subscribe":             "Assinar",
      "billing_recommended":           "Recomendado para o teu rebanho",
      "billing_enterprise_title":      "Plano sob medida",
      "billing_enterprise_desc":       "A partir de {{min}} animais. Montamos um plano sob medida para a tua operação.",
      "billing_contact_us":            "Fala conosco",
      "contact_us":                    "Fala conosco",
      "contact_us_section_title":      "Fala com a gente",
      "contact_us_section_text":       "Dúvidas sobre o teu rebanho, o teu plano ou como começar? Manda uma mensagem no WhatsApp para a resposta mais rápida, ou escreve pra gente e respondemos por e-mail.",
      "contact_whatsapp_title":        "Conversa com a gente no WhatsApp",
      "contact_whatsapp_text":         "Fala direto com a gente no app que tu já usas todo dia. Quem responde é uma pessoa, não uma central de atendimento.",
      "contact_whatsapp_button":       "Abrir o WhatsApp",
      "contact_whatsapp_prefill":      "Olá ZapManejo — preciso de ajuda com a minha conta.",
      "contact_email_title":           "Manda uma mensagem",
      "contact_email_text":            "Preferes escrever? Preenche o formulário abaixo e respondemos por e-mail.",
      "contact_message_label":         "Mensagem",
      "contact_message_placeholder":   "Como podemos ajudar na tua operação?",
      "contact_context_note":          "Mandamos junto a tua conta e a tua fazenda ({{ranch}}) para te encontrarmos mais rápido.",
      "contact_sent_title":            "Mensagem enviada.",
      "contact_sent_text":             "Obrigado pelo contato — respondemos por e-mail em breve. Com pressa? Manda uma mensagem no WhatsApp.",
      "contact_send_another":          "Mandar outra mensagem",
      "contact_name_invalid":          "Diz o teu nome.",
      "contact_email_invalid":         "Esse e-mail parece errado.",
      "contact_phone_invalid":         "Esse telefone é longo demais.",
      "contact_message_too_short":     "Conta um pouco mais, assim a gente te ajuda melhor.",
      "contact_message_too_long":      "A mensagem está muito longa. Encurta um pouco.",
      "contact_rate_limited":          "Tu mandaste várias mensagens há pouco. Tenta de novo daqui a pouco ou usa o WhatsApp.",
      "contact_send_failed":           "Algo deu errado ao mandar a tua mensagem. Tenta de novo ou escreve no WhatsApp.",
      "billing_current_plan":          "Plano atual",
      "billing_current_badge":         "Teu plano",
      "billing_billed_month":          "Cobrança mensal",
      "billing_billed_year":           "Cobrança anual",
      "billing_change_plan_note":      "Para mudar de plano ou de período, usa Gerenciar assinatura.",
      "billing_payment_problem_title": "Problema no pagamento",
      "billing_payment_problem":       "Há um problema com o pagamento do teu plano {{band}}. Atualiza a forma de pagamento em Gerenciar assinatura para continuar.",
      "billing_active_plan":           "Plano ativo",
      "billing_active_plan_desc":      "A tua conta tem um plano ativo com acesso a todos os recursos.",
      "billing_load_error":            "Não foi possível carregar os planos. Tenta de novo mais tarde.",
      "billing_error_generic":         "Não foi possível iniciar o pagamento. Tenta de novo.",
      // Códigos de erro da API (POST /api/billing/checkout e GET /api/billing/plans).
      // As chaves são iguais aos códigos: Fetch (Utils.js) traduz {"error": code} pela chave.
      "invalid_request":               "Pedido inválido. Recarrega a página e tenta de novo.",
      "invalid_band":                  "Plano inválido. Recarrega a página e escolhe de novo.",
      "invalid_interval":              "Período de cobrança inválido. Escolhe mensal ou anual.",
      "free_plan_no_checkout":         "O plano gratuito não precisa de pagamento.",
      "enterprise_contact_us":         "Para um rebanho desse tamanho, fala conosco para um plano sob medida.",
      "already_subscribed":            "Tu já tens uma assinatura. Para mudar de plano, usa Gerenciar assinatura.",
      "price_not_configured":          "Este plano ainda não está disponível para contratação. Fala conosco.",
      "stripe_unavailable":            "Não foi possível falar com o sistema de pagamento. Tenta de novo em alguns minutos.",

      // i18n PT Coverage Phase 1 (Mode A + C — recon 2026-04-27)
      "unit_kg":                    "kg",
      "tag_number_placeholder":     "Número do Brinco",
      "add_to_specific_lot":        "Adicionar a lote específico?",
      "use_default_lot":            "Usar lote padrão",
      "tag_and_lot_required":       "Brinco e lote são obrigatórios.",
      "error_saving":               "Erro ao salvar. Tente novamente.",
      "phone_format_us":            "1-xxx-xxx-xxxx",
      "phone_format_br":            "xx-xx-xxxxx-xxxx",
      "rainfall_placeholder":       "Chuva em mm",
      "temperature_placeholder":    "Temperatura (Celsius)",
      "repro_status_unknown":       "Desconhecido",
      "repro_status_completed":     "Concluído",
      "repro_status_due_today":     "Vence Hoje",
      "repro_status_missed":        "Perdido",
      "repro_status_pending":       "Pendente",
      "repro_status_not_completed": "Não Concluído",
      "no_actions_for_step":        "Nenhuma ação definida para esta etapa ainda",
      "error_user_not_found":       "Usuário não encontrado",
      "error_no_phone_numbers":     "Nenhum número de telefone disponível. Entre em contato com o suporte.",
      "samples_weather_user_input":           "clima para Belém PA",
      "samples_weather_response":             "Zap Manejo Clima:\nEndereço: Belém, PA 66000-000, Brasil\nHora: 2026-02-18T14:30:00\nCondição: Parcialmente Nublado\nTemperatura: 28.5 °C\nPrecipitação: 10% Chuva Leve",
      "samples_lot_specific_bull_user_input": "novo lote angus",
      "samples_lot_specific_bull_response":   "Zap Manejo criou um lote usando o protocolo 'Protocolo Padrão'.\n*REPRO-0043*\n\nData de Início: 2026-02-18 (Dia 0)\nTouro: Angus Prime\n\nTarefas do Dia 0:\n- Inserir implante\n- Aplicar GnRH\n\nVocê pode adicionar animais a este lote pelo painel.",
      "samples_lot_status_user_input":        "REPRO-0042",
      "samples_lot_status_response":          "🔬 *REPRO-0042 — Rebanho Norte*\nMarcados: 22\nInício: 2026-08-01\nDia: 12\n\n📋 Protocolo: CO-Synch + CIDR de 9 Dias\nEtapa 3 de 5:\n  · Remover CIDR\n  · Aplicar injeção de PGF2α\nResponda \"REPRO-0042 done\" quando concluir.\n\n📝 Comandos:\n\nPara adicionar animais ao lote:\nREPRO-0042 {brinco1} {brinco2} ...\n\nNascimentos: 18\nAbortos: 2\nFalhas de concepção: 1\nMortes de matriz: 1\nTaxa de sucesso: 86%",

      // i18n PT Coverage Phase 2 (recon 2026-04-29)
      "age_months":                  "meses",
      "age_years":                   "anos",
      "language_portuguese":         "Português",
      "language_english":            "Inglês",
      "pagination_rows_per_page":    "Linhas por página:",
      "pagination_range_separator":  "de",
      "pagination_select_all":       "Todos",
      "reproduction_result":         "Resultado",
      "repro_result_choose":         "-- Escolher Resultado --",
      "males_cannot_be_added_to_reproduction_lot":          "Apenas animais fêmeas podem ser adicionados a um lote de reprodução.",
      "only_female_animals_can_have_reproduction_outcome":  "Apenas animais fêmeas podem ter um resultado de reprodução registrado.",
      "bull_tag_not_found":                                 "Nenhum animal encontrado com esse número de brinco.",
      "bull_tag_not_male":                                  "Esse número de brinco pertence a um animal fêmea — o brinco de um touro deve ser de um animal macho.",
      "upload_choose_file":          "Selecionar Arquivo CSV",
      "upload_button":               "Enviar",
      "transaction_amount":          "Valor",
      "column_type":                 "Tipo",
      "type":                        "Tipo",
      "header_subtitle":             "Painel da Web",
      "change_successful":           "Alteração efetuada com sucesso",
      "birth_duplicate_error":       "Já existe um nascimento com esse brinco.",
      "death_duplicate_error":       "Já existe uma morte com esse brinco.",
      "zootecnista":                 "Zootecnista",
      "agronomo":                    "Agrônomo",
      "institution_other":           "Outros",
      "institution_cash":            "Dinheiro",
      "institution_bank":            "Banco",
      "institution_farm_credit":     "Crédito Rural",
      "institution_credit_card":     "Cartão de Crédito",
      "institution_check":           "Cheque",
    }
  }
};

export const getLang = () => {
  const user = localStorage.getItem('zapmanejo_user');
  if ((user === null) || (user === undefined)) {
    return navigator.language;
  }
  const juser = JSON.parse(user);
  if ((juser.lang === "en-US") || (juser.lang === "pt-BR")) {
    return juser.lang;
  }
  return navigator.language;
}

i18n
  .use(initReactI18next) 
  .init({
    resources,
    lng: getLang(),
    interpolation: {
      escapeValue: false 
    }
  });

export default i18n;
